// This file is auto-generated. Do not edit!

export default [
  {
    bpt: "0x01536b22ea06e4A315E3DAAF05a12683Ed4dc14c",
    id: "0x01536b22ea06e4a315e3daaf05a12683ed4dc14c0000000000000000000005fc",
    name: "e-cs-kp-usd",
    type: "ComposableStable",
    gauge: null,
    tokens: [
      {
        address: "0x571f54D23cDf2211C83E9A0CbD92AcA36c48Fa02",
        symbol: "paUSD",
      },
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
      {
        address: "0xaF4ce7CD4F8891ecf1799878c3e9A35b8BE57E09",
        symbol: "wUSK",
      },
    ],
  },
  {
    bpt: "0x01abc00E86C7e258823b9a055Fd62cA6CF61a163",
    id: "0x01abc00e86c7e258823b9a055fd62ca6cf61a16300010000000000000000003b",
    name: "DREV",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x0bc529c00C6401aEF6D220BE8C6Ea1667F6Ad93e",
        symbol: "YFI",
      },
      {
        address: "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984",
        symbol: "UNI",
      },
      {
        address: "0x6B3595068778DD592e39A122f4f5a5cF09C90fE2",
        symbol: "SUSHI",
      },
      {
        address: "0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9",
        symbol: "AAVE",
      },
      {
        address: "0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2",
        symbol: "MKR",
      },
      {
        address: "0xba100000625a3754423978a60c9317c58a424e3D",
        symbol: "BAL",
      },
      {
        address: "0xc00e94Cb662C3520282E6f5717214004A7f26888",
        symbol: "COMP",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x0297e37f1873D2DAb4487Aa67cD56B58E2F27875",
    id: "0x0297e37f1873d2dab4487aa67cd56b58e2f27875000200000000000000000003",
    name: "B-50WBTC-50WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
        symbol: "WBTC",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x02CA8086498552C071451724D3A34cAA3922b65a",
    id: "0x02ca8086498552c071451724d3a34caa3922b65a000200000000000000000613",
    name: "80ROOT-20WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x8d2658E0F52dF7875A7b3e58FC12F82F5e34dd61",
        symbol: "ROOT",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x034E2d995B39A88aB9a532A9BF0deDDac2c576eA",
    id: "0x034e2d995b39a88ab9a532a9bf0deddac2c576ea0002000000000000000005d1",
    name: "80SD-20ETHx",
    type: "Weighted",
    gauge: "0x13Dd3Eaecfb09A1EA9cED4A21CA47Ca7852C9694",
    tokens: [
      {
        address: "0x30D20208d987713f46DFD34EF128Bb16C404D10f",
        symbol: "SD",
      },
      {
        address: "0xA35b1B31Ce002FBF2058D22F30f95D405200A15b",
        symbol: "ETHx",
      },
    ],
  },
  {
    bpt: "0x0578292CB20a443bA1CdE459c985CE14Ca2bDEe5",
    id: "0x0578292cb20a443ba1cde459c985ce14ca2bdee5000100000000000000000269",
    name: "33auraBAL-33graviAURA-33WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x616e8BfA43F920657B3497DBf40D6b1A02D4608d",
        symbol: "auraBAL",
      },
      {
        address: "0xBA485b556399123261a5F9c95d413B4f93107407",
        symbol: "graviAURA",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x06Df3b2bbB68adc8B0e302443692037ED9f91b42",
    id: "0x06df3b2bbb68adc8b0e302443692037ed9f91b42000000000000000000000063",
    name: "staBAL3",
    type: "Stable",
    gauge: null,
    tokens: [
      {
        address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
        symbol: "DAI",
      },
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
      {
        address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
        symbol: "USDT",
      },
    ],
  },
  {
    bpt: "0x072f14B85ADd63488DDaD88f855Fda4A99d6aC9B",
    id: "0x072f14b85add63488ddad88f855fda4a99d6ac9b000200000000000000000027",
    name: "B-50SNX-50WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F",
        symbol: "SNX",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x08775ccb6674d6bDCeB0797C364C2653ED84F384",
    id: "0x08775ccb6674d6bdceb0797c364c2653ed84f3840002000000000000000004f0",
    name: "50WETH-50-3pool",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
        symbol: "DAI",
      },
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
      {
        address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
        symbol: "USDT",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x08cC92fEdc1cE2D8525176a63FcfF404450f2998",
    id: "0x08cc92fedc1ce2d8525176a63fcff404450f2998000200000000000000000542",
    name: "50B-baoUSD-LUSD-BPT-50BAO",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x7E9AfD25F5Ec0eb24d7d4b089Ae7EcB9651c8b1F",
        symbol: "B-baoUSD-LUSD-BPT",
      },
      {
        address: "0xCe391315b414D4c7555956120461D21808A69F3A",
        symbol: "BAO",
      },
    ],
  },
  {
    bpt: "0x093254005743b7Af89e24F645730Ba2dD8441333",
    id: "0x093254005743b7af89e24f645730ba2dd84413330002000000000000000006a4",
    name: "50APW-50WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x4104b135DBC9609Fc1A9490E61369036497660c8",
        symbol: "APW",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x0947592314Bf2BD0f86A74299bc8e534e3c7313f",
    id: "0x0947592314bf2bd0f86a74299bc8e534e3c7313f000200000000000000000312",
    name: "20WETH-80JELLY",
    type: "Weighted",
    gauge: "0x6BcdC06bdECa203f84409dAe4692eE2b9619f399",
    tokens: [
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xf5f06fFa53Ad7F5914F493F16E57B56C8dd2eA80",
        symbol: "JELLY",
      },
    ],
  },
  {
    bpt: "0x09804CaEA2400035b18E2173fdD10EC8b670cA09",
    id: "0x09804caea2400035b18e2173fdd10ec8b670ca09000100000000000000000038",
    name: "BLU",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x04Fa0d235C4abf4BcF4787aF4CF447DE572eF828",
        symbol: "UMA",
      },
      {
        address: "0x0bc529c00C6401aEF6D220BE8C6Ea1667F6Ad93e",
        symbol: "YFI",
      },
      {
        address: "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984",
        symbol: "UNI",
      },
      {
        address: "0x514910771AF9Ca656af840dff83E8264EcF986CA",
        symbol: "LINK",
      },
      {
        address: "0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9",
        symbol: "AAVE",
      },
      {
        address: "0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2",
        symbol: "MKR",
      },
      {
        address: "0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F",
        symbol: "SNX",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x0A8156fdc4B488CB1Bf1c44c7eE944088174Fa30",
    id: "0x0a8156fdc4b488cb1bf1c44c7ee944088174fa30000200000000000000000319",
    name: "80MYC-20WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x4b13006980aCB09645131b91D259eaA111eaF5Ba",
        symbol: "MYC",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x0AAba3D6a05a606b7A794877Dd0beFDa47474dB0",
    id: "0x0aaba3d6a05a606b7a794877dd0befda47474db00002000000000000000006d2",
    name: "B-KAI-WETH-WEIGHTED",
    type: "Weighted",
    gauge: "0x80CD37A62A8A58C4Cbf64003410c5cCC4d01519f",
    tokens: [
      {
        address: "0x63e5dC7C071C1F18d44b69bc86f4c80F24851388",
        symbol: "KAI",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x0b09deA16768f0799065C475bE02919503cB2a35",
    id: "0x0b09dea16768f0799065c475be02919503cb2a3500020000000000000000001a",
    name: "B-60WETH-40DAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
        symbol: "DAI",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x0BF37157d30dFe6f56757DCadff01AEd83b08cD6",
    id: "0x0bf37157d30dfe6f56757dcadff01aed83b08cd600020000000000000000019a",
    name: "80NATION-20WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x333A4823466879eeF910A04D473505da62142069",
        symbol: "NATION",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x100A6a9524541E92dd068a9cd3E5DEF16388Fec0",
    id: "0x100a6a9524541e92dd068a9cd3e5def16388fec0000200000000000000000213",
    name: "50COIN-50WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x06C985FF69F7257e212a89828f79497a3c8B6eDf",
        symbol: "COIN",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x127ECc2318d002664cc4515C9f2B22B09b6aea85",
    id: "0x127ecc2318d002664cc4515c9f2b22b09b6aea85000200000000000000000602",
    name: "ECLP-swETH-wstETH",
    type: "GyroE",
    gauge: "0x0f58a431A2B6023686c40559DdE19C0d1A9D0AeF",
    tokens: [
      {
        address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
        symbol: "wstETH",
      },
      {
        address: "0xf951E335afb289353dc249e82926178EaC7DEd78",
        symbol: "swETH",
      },
    ],
  },
  {
    bpt: "0x14462305D211C12A736986F4E8216E28c5EA7Ab4",
    id: "0x14462305d211c12a736986f4e8216e28c5ea7ab4000200000000000000000068",
    name: "BPTGRTUSDC",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
      {
        address: "0xc944E90C64B2c07662A292be6244BDf05Cda44a7",
        symbol: "GRT",
      },
    ],
  },
  {
    bpt: "0x148CE9b50bE946a96e94A4f5479b771bAB9B1c59",
    id: "0x148ce9b50be946a96e94a4f5479b771bab9b1c59000100000000000000000054",
    name: "B-BGP",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x6810e776880C02933D47DB1b9fc05908e5386b96",
        symbol: "GNO",
      },
      {
        address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
        symbol: "DAI",
      },
      {
        address: "0xba100000625a3754423978a60c9317c58a424e3D",
        symbol: "BAL",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x158e0fBC2271E1dCEbadD365a22E2B4dD173C0DB",
    id: "0x158e0fbc2271e1dcebadd365a22e2b4dd173c0db0002000000000000000005a5",
    name: "80IDLE-20USDC",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x875773784Af8135eA0ef43b5a374AaD105c5D39e",
        symbol: "IDLE",
      },
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0x16faF9f73748013155B7bC116a3008b57332D1e6",
    id: "0x16faf9f73748013155b7bc116a3008b57332d1e600020000000000000000001c",
    name: "B-70RPL-30WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xB4EFd85c19999D84251304bDA99E90B92300Bd93",
        symbol: "RPL",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x178E029173417b1F9C8bC16DCeC6f697bC323746",
    id: "0x178e029173417b1f9c8bc16dcec6f697bc32374600000000000000000000025d",
    name: "FUD",
    type: "Stable",
    gauge: null,
    tokens: [
      {
        address: "0x586Aa273F262909EEF8fA02d90Ab65F5015e0516",
        symbol: "FIAT",
      },
      {
        address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
        symbol: "DAI",
      },
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0x186084fF790C65088BA694Df11758faE4943EE9E",
    id: "0x186084ff790c65088ba694df11758fae4943ee9e000200000000000000000013",
    name: "B-50WETH-50YFI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x0bc529c00C6401aEF6D220BE8C6Ea1667F6Ad93e",
        symbol: "YFI",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x18FDf15ff782e44C1f9B6C5846ff6B0F0004F6a2",
    id: "0x18fdf15ff782e44c1f9b6c5846ff6b0f0004f6a2000200000000000000000560",
    name: "50OHM-50LUSD",
    type: "Weighted",
    gauge: "0x7F244b47C63E9Ca33A58E6550bfd1D3dC806Ce55",
    tokens: [
      {
        address: "0x5f98805A4E8be255a32880FDeC7F6728C6568bA0",
        symbol: "LUSD",
      },
      {
        address: "0x64aa3364F17a4D01c6f1751Fd97C2BD3D7e7f1D5",
        symbol: "OHM",
      },
    ],
  },
  {
    bpt: "0x1A44E35d5451E0b78621A1B3e7a53DFaA306B1D0",
    id: "0x1a44e35d5451e0b78621a1b3e7a53dfaa306b1d000000000000000000000051b",
    name: "B-baoETH-ETH-BPT",
    type: "ComposableStable",
    gauge: null,
    tokens: [
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xf4edfad26EE0D23B69CA93112eccE52704E0006f",
        symbol: "baoETH",
      },
    ],
  },
  {
    bpt: "0x1b65fe4881800B91d4277ba738b567CbB200A60d",
    id: "0x1b65fe4881800b91d4277ba738b567cbb200a60d0002000000000000000002cc",
    name: "80TEMPLE-20DAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x470EBf5f030Ed85Fc1ed4C2d36B9DD02e77CF1b7",
        symbol: "TEMPLE",
      },
      {
        address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
        symbol: "DAI",
      },
    ],
  },
  {
    bpt: "0x1b6e13673f29688e27311B332aF1527f1ebF1D28",
    id: "0x1b6e13673f29688e27311b332af1527f1ebf1d28000200000000000000000546",
    name: "80PSDN-20WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xA5B947687163FE88C3e6af5b17Ae69896F4abccf",
        symbol: "PSDN",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x1bCCAaC02BAe336c6352Acc3b772059EF1142fa7",
    id: "0x1bccaac02bae336c6352acc3b772059ef1142fa70002000000000000000001f0",
    name: "50XNS-50WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x79c71D3436F39Ce382D0f58F1B011D88100B9D91",
        symbol: "XNS",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x1CCE5169bDe03f3d5aD0206f6BD057953539DAE6",
    id: "0x1cce5169bde03f3d5ad0206f6bd057953539dae600020000000000000000062b",
    name: "ECLP-GYD-sDAI",
    type: "GyroE",
    gauge: "0xFc3f916C28f32DEBA1cc04b1F6011F28a691134c",
    tokens: [
      {
        address: "0x83F20F44975D03b1b09e64809B757c47f942BEeA",
        symbol: "sDAI",
      },
      {
        address: "0xe07F9D810a48ab5c3c914BA3cA53AF14E4491e8A",
        symbol: "GYD",
      },
    ],
  },
  {
    bpt: "0x1E19CF2D73a72Ef1332C882F20534B6519Be0276",
    id: "0x1e19cf2d73a72ef1332c882f20534b6519be0276000200000000000000000112",
    name: "B-rETH-STABLE",
    type: "MetaStable",
    gauge: "0x79eF6103A513951a3b25743DB509E267685726B7",
    tokens: [
      {
        address: "0xae78736Cd615f374D3085123A210448E74Fc6393",
        symbol: "rETH",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x1ee442b5326009Bb18F2F472d3e0061513d1A0fF",
    id: "0x1ee442b5326009bb18f2f472d3e0061513d1a0ff000200000000000000000464",
    name: "50rETH-50BADGER",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x3472A5A71965499acd81997a54BBA8D852C6E53d",
        symbol: "BADGER",
      },
      {
        address: "0xae78736Cd615f374D3085123A210448E74Fc6393",
        symbol: "rETH",
      },
    ],
  },
  {
    bpt: "0x20FacEcaa68E9b7c92d2d0ec9136D864Df805233",
    id: "0x20facecaa68e9b7c92d2d0ec9136d864df805233000100000000000000000190",
    name: "WILDFIRE",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9",
        symbol: "AAVE",
      },
      {
        address: "0xba100000625a3754423978a60c9317c58a424e3D",
        symbol: "BAL",
      },
      {
        address: "0xba5BDe662c17e2aDFF1075610382B9B691296350",
        symbol: "RARE",
      },
      {
        address: "0xC18360217D8F7Ab5e7c516566761Ea12Ce7F9D72",
        symbol: "ENS",
      },
      {
        address: "0xD33526068D116cE69F19A9ee46F0bd304F21A51f",
        symbol: "RPL",
      },
      {
        address: "0xDe30da39c46104798bB5aA3fe8B9e0e1F348163F",
        symbol: "GTC",
      },
      {
        address: "0xf2051511B9b121394FA75B8F7d4E7424337af687",
        symbol: "HAUS",
      },
      {
        address: "0xfb5453340C03db5aDe474b27E68B6a9c6b2823Eb",
        symbol: "ROBOT",
      },
    ],
  },
  {
    bpt: "0x2191Df821C198600499aA1f0031b1a7514D7A7D9",
    id: "0x2191df821c198600499aa1f0031b1a7514d7a7d9000200000000000000000639",
    name: "ECLP-GYD-sDAI",
    type: "GyroE",
    gauge: "0x0fD5B305C5e09D8A74732F155116dEd43115E421",
    tokens: [
      {
        address: "0x83F20F44975D03b1b09e64809B757c47f942BEeA",
        symbol: "sDAI",
      },
      {
        address: "0xe07F9D810a48ab5c3c914BA3cA53AF14E4491e8A",
        symbol: "GYD",
      },
    ],
  },
  {
    bpt: "0x231E687C9961d3A27e6E266Ac5C433Ce4F8253E4",
    id: "0x231e687c9961d3a27e6e266ac5c433ce4f8253e4000200000000000000000023",
    name: "B-50SRM-50WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x476c5E26a75bd202a9683ffD34359C0CC15be0fF",
        symbol: "SRM",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x23a07596cF915CCcDFD5Ea8EC7e0268ba5488478",
    id: "0x23a07596cf915cccdfd5ea8ec7e0268ba548847800020000000000000000037d",
    name: "50GUILD-50MC",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x83E9F223e1edb3486F876EE888d76bFba26c475A",
        symbol: "GUILD",
      },
      {
        address: "0x949D48EcA67b17269629c7194F4b727d4Ef9E5d6",
        symbol: "MC",
      },
    ],
  },
  {
    bpt: "0x264062CA46A1322c2E6464471764089E01F22F19",
    id: "0x264062ca46a1322c2e6464471764089e01f22f1900000000000000000000066b",
    name: "sDOLA-DOLA BSP",
    type: "ComposableStable",
    gauge: null,
    tokens: [
      {
        address: "0x865377367054516e17014CcdED1e7d814EDC9ce4",
        symbol: "DOLA",
      },
      {
        address: "0xb45ad160634c528Cc3D2926d9807104FA3157305",
        symbol: "sDOLA",
      },
    ],
  },
  {
    bpt: "0x26Cc136e9b8FD65466F193a8e5710661Ed9A9827",
    id: "0x26cc136e9b8fd65466f193a8e5710661ed9a98270002000000000000000005ad",
    name: "80BETS/20wstETH",
    type: "Weighted",
    gauge: "0x521824093f7341A66E9284Cf9Af76F0bE0855f0d",
    tokens: [
      {
        address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
        symbol: "wstETH",
      },
      {
        address: "0x94025780a1aB58868D9B2dBBB775f44b32e8E6e5",
        symbol: "BETS",
      },
    ],
  },
  {
    bpt: "0x271d57cE059780462F89800141A089008Ca78D4a",
    id: "0x271d57ce059780462f89800141a089008ca78d4a000200000000000000000616",
    name: "80PRTC-20WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xb9098D3669A78e9AfE8b94a97290407400D9dA31",
        symbol: "PRTC",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x27C9f71cC31464B906E0006d4FcBC8900F48f15f",
    id: "0x27c9f71cc31464b906e0006d4fcbc8900f48f15f00020000000000000000010f",
    name: "80D2D-20USDC",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x43D4A3cd90ddD2F8f4f693170C9c8098163502ad",
        symbol: "D2D",
      },
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0x2875f3eFfE9Ec897D7e4C32680D77cA3E628f33a",
    id: "0x2875f3effe9ec897d7e4c32680d77ca3e628f33a0002000000000000000006d1",
    name: "ECLP-GYD-USDC",
    type: "GyroE",
    gauge: "0x9C1A157cf8B242F67b3c950EDA9A30b320bDe9cd",
    tokens: [
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
      {
        address: "0xe07F9D810a48ab5c3c914BA3cA53AF14E4491e8A",
        symbol: "GYD",
      },
    ],
  },
  {
    bpt: "0x29d7a7E0d781C957696697B94D4Bc18C651e358E",
    id: "0x29d7a7e0d781c957696697b94d4bc18c651e358e000200000000000000000049",
    name: "PAR50-WETH50",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x68037790A0229e9Ce6EaA8A99ea92964106C4703",
        symbol: "PAR",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x2b6Af1B557c4f81A238a38f1C2DC51Cda0cEb45b",
    id: "0x2b6af1b557c4f81a238a38f1c2dc51cda0ceb45b0002000000000000000006ec",
    name: "LP-LNDX-ETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x08A1C30BBB26425c1031ee9E43FA0B9960742539",
        symbol: "LNDX",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x2d011aDf89f0576C9B722c28269FcB5D50C2d179",
    id: "0x2d011adf89f0576c9b722c28269fcb5d50c2d17900020000000000000000024d",
    name: "B-sdBAL-STABLE",
    type: "Stable",
    gauge: "0xDc2Df969EE5E66236B950F5c4c5f8aBe62035df2",
    tokens: [
      {
        address: "0x5c6Ee304399DBdB9C8Ef030aB642B10820DB8F56",
        symbol: "B-80BAL-20WETH",
      },
      {
        address: "0xF24d8651578a55b0C119B9910759a351A3458895",
        symbol: "sdBal",
      },
    ],
  },
  {
    bpt: "0x2D344A84BaC123660b021EEbE4eB6F12ba25fe86",
    id: "0x2d344a84bac123660b021eebe4eb6f12ba25fe8600020000000000000000018a",
    name: "20WETH-80FDT",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xEd1480d12bE41d92F36f5f7bDd88212E381A3677",
        symbol: "FDT",
      },
    ],
  },
  {
    bpt: "0x2D6e3515C8b47192Ca3913770fa741d3C4Dac354",
    id: "0x2d6e3515c8b47192ca3913770fa741d3c4dac35400020000000000000000007b",
    name: "LPeYyvUSDC-29OCT21",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x5D67C1c829AB93867d865CF2008DEb45df67044f",
        symbol: "eYyvUSDC-29OCT21",
      },
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0x2dE32a7c98C3ef6ec79e703500e8CA5b2eC819aa",
    id: "0x2de32a7c98c3ef6ec79e703500e8ca5b2ec819aa00020000000000000000031c",
    name: "50/50 BTRFLY-OHM",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x64aa3364F17a4D01c6f1751Fd97C2BD3D7e7f1D5",
        symbol: "OHM",
      },
      {
        address: "0xc55126051B22eBb829D00368f4B12Bde432de5Da",
        symbol: "BTRFLY",
      },
    ],
  },
  {
    bpt: "0x319438FDD5D27922aCeD2a1b15CD7F0bc3B03068",
    id: "0x319438fdd5d27922aced2a1b15cd7f0bc3b03068000100000000000000000261",
    name: "45WBTC-10graviAURA-45WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
        symbol: "WBTC",
      },
      {
        address: "0xBA485b556399123261a5F9c95d413B4f93107407",
        symbol: "graviAURA",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x32296969Ef14EB0c6d29669C550D4a0449130230",
    id: "0x32296969ef14eb0c6d29669c550d4a0449130230000200000000000000000080",
    name: "B-stETH-STABLE",
    type: "MetaStable",
    gauge: null,
    tokens: [
      {
        address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
        symbol: "wstETH",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x344e8f99a55DA2ba6B4b5158df2143374E400DF2",
    id: "0x344e8f99a55da2ba6b4b5158df2143374e400df2000100000000000000000079",
    name: "NFTG",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x0eC9F76202a7061eB9b3a7D6B59D36215A7e37da",
        symbol: "BPT",
      },
      {
        address: "0x18aAA7115705e8be94bfFEBDE57Af9BFc265B998",
        symbol: "AUDIO",
      },
      {
        address: "0x25f8087EAD173b73D6e8B84329989A8eEA16CF73",
        symbol: "YGG",
      },
      {
        address: "0x3845badAde8e6dFF049820680d1F14bD3903a5d0",
        symbol: "SAND",
      },
      {
        address: "0x87d73E916D7057945c9BcD8cdd94e42A6F47f776",
        symbol: "NFTX",
      },
      {
        address: "0xB6Ca7399B4F9CA56FC27cBfF44F4d2e4Eef1fc81",
        symbol: "MUSE",
      },
      {
        address: "0xBB0E17EF65F82Ab018d8EDd776e8DD940327B28b",
        symbol: "AXS",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x350196326AEAA9b98f1903fb5e8fc2686f85318C",
    id: "0x350196326aeaa9b98f1903fb5e8fc2686f85318c000200000000000000000084",
    name: "VBPT",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x81f8f0bb1cB2A06649E51913A151F0E7Ef6FA321",
        symbol: "VITA",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x35c264f24F3A2fB0B9025905D3bBf10874B055AA",
    id: "0x35c264f24f3a2fb0b9025905d3bbf10874b055aa0001000000000000000002c4",
    name: "10BAT-20WBTC-10REN-20MATIC-20SNX-20WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x0D8775F648430679A709E98d2b0Cb6250d2887EF",
        symbol: "BAT",
      },
      {
        address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
        symbol: "WBTC",
      },
      {
        address: "0x408e41876cCCDC0F92210600ef50372656052a38",
        symbol: "REN",
      },
      {
        address: "0x7D1AfA7B718fb893dB30A3aBc0Cfc608AaCfeBB0",
        symbol: "MATIC",
      },
      {
        address: "0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F",
        symbol: "SNX",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x36Be1E97eA98AB43b4dEBf92742517266F5731a3",
    id: "0x36be1e97ea98ab43b4debf92742517266f5731a3000200000000000000000466",
    name: "50wstETH-50ACX",
    type: "Weighted",
    gauge: "0xf7B0751Fea697cf1A541A5f57D11058a8fB794ee",
    tokens: [
      {
        address: "0x44108f0223A3C3028F5Fe7AEC7f9bb2E66beF82F",
        symbol: "ACX",
      },
      {
        address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
        symbol: "wstETH",
      },
    ],
  },
  {
    bpt: "0x380aAbE019ed2a9C2d632b51eDDD30fd804d0fAD",
    id: "0x380aabe019ed2a9c2d632b51eddd30fd804d0fad000200000000000000000554",
    name: "50R-50wstETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x183015a9bA6fF60230fdEaDc3F43b3D788b13e21",
        symbol: "R",
      },
      {
        address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
        symbol: "wstETH",
      },
    ],
  },
  {
    bpt: "0x382dC5b2eCa1C1308Eb7e2B40c0F571AFB899aC8",
    id: "0x382dc5b2eca1c1308eb7e2b40c0f571afb899ac8000100000000000000000557",
    name: "14DNT-14WBTC-14VEE-14KEY-14SNT-14QSP-14WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x0AbdAce70D3790235af448C88547603b945604ea",
        symbol: "DNT",
      },
      {
        address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
        symbol: "WBTC",
      },
      {
        address: "0x340D2bdE5Eb28c1eed91B2f790723E3B160613B7",
        symbol: "VEE",
      },
      {
        address: "0x4CC19356f2D37338b9802aa8E8fc58B0373296E7",
        symbol: "KEY",
      },
      {
        address: "0x744d70FDBE2Ba4CF95131626614a1763DF805B9E",
        symbol: "SNT",
      },
      {
        address: "0x99ea4dB9EE77ACD40B119BD1dC4E33e1C070b80d",
        symbol: "QSP",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x38A01c45D86b61A70044fB2A76eAC8e75B1ac78E",
    id: "0x38a01c45d86b61a70044fb2a76eac8e75b1ac78e00020000000000000000003a",
    name: "WBLC",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
        symbol: "DAI",
      },
      {
        address: "0x0bc529c00C6401aEF6D220BE8C6Ea1667F6Ad93e",
        symbol: "YFI",
      },
      {
        address: "0x7D1AfA7B718fb893dB30A3aBc0Cfc608AaCfeBB0",
        symbol: "MATIC",
      },
      {
        address: "0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9",
        symbol: "AAVE",
      },
      {
        address: "0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2",
        symbol: "MKR",
      },
      {
        address: "0xba100000625a3754423978a60c9317c58a424e3D",
        symbol: "BAL",
      },
      {
        address: "0xc00e94Cb662C3520282E6f5717214004A7f26888",
        symbol: "COMP",
      },
      {
        address: "0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F",
        symbol: "SNX",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x3932b187f440cE7703653b3908EDc5bB7676C283",
    id: "0x3932b187f440ce7703653b3908edc5bb7676c283000200000000000000000664",
    name: "ECLP-GHO-USDC-2",
    type: "GyroE",
    gauge: null,
    tokens: [
      {
        address: "0x40D16FC0246aD3160Ccc09B8D0D3A2cD28aE6C2f",
        symbol: "GHO",
      },
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0x39eB558131E5eBeb9f76a6cbf6898f6E6DCe5e4E",
    id: "0x39eb558131e5ebeb9f76a6cbf6898f6e6dce5e4e0002000000000000000005c8",
    name: "QI BPT",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x559b7bfC48a5274754b08819F75C5F27aF53D53b",
        symbol: "QI",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x3A2819B07981234F825E952f32Cf977db5EDBf7C",
    id: "0x3a2819b07981234f825e952f32cf977db5edbf7c00020000000000000000066f",
    name: "80UNION-20wstETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x5Dfe42eEA70a3e6f93EE54eD9C321aF07A85535C",
        symbol: "UNION",
      },
      {
        address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
        symbol: "wstETH",
      },
    ],
  },
  {
    bpt: "0x3B40D7d5AE25dF2561944dD68b252016c4c7B280",
    id: "0x3b40d7d5ae25df2561944dd68b252016c4c7b2800001000000000000000000c2",
    name: "WSB-DEFI",
    type: "Investment",
    gauge: null,
    tokens: [
      {
        address: "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984",
        symbol: "UNI",
      },
      {
        address: "0x6B3595068778DD592e39A122f4f5a5cF09C90fE2",
        symbol: "SUSHI",
      },
      {
        address: "0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9",
        symbol: "AAVE",
      },
      {
        address: "0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2",
        symbol: "MKR",
      },
      {
        address: "0xc00e94Cb662C3520282E6f5717214004A7f26888",
        symbol: "COMP",
      },
      {
        address: "0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F",
        symbol: "SNX",
      },
      {
        address: "0xc944E90C64B2c07662A292be6244BDf05Cda44a7",
        symbol: "GRT",
      },
      {
        address: "0xD533a949740bb3306d119CC777fa900bA034cd52",
        symbol: "CRV",
      },
    ],
  },
  {
    bpt: "0x3B9Fb87F7d081CEDdb1289258FA5660d955317b6",
    id: "0x3b9fb87f7d081ceddb1289258fa5660d955317b6000200000000000000000544",
    name: "50B-baoETH-ETH-BPT-50BAO",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xf4edfad26EE0D23B69CA93112eccE52704E0006f",
        symbol: "baoETH",
      },
      {
        address: "0xCe391315b414D4c7555956120461D21808A69F3A",
        symbol: "BAO",
      },
    ],
  },
  {
    bpt: "0x3dd0843A028C86e0b760b1A76929d1C5Ef93a2dd",
    id: "0x3dd0843a028c86e0b760b1a76929d1c5ef93a2dd000200000000000000000249",
    name: "B-auraBAL-STABLE",
    type: "Stable",
    gauge: "0x0312AA8D0BA4a1969Fddb382235870bF55f7f242",
    tokens: [
      {
        address: "0x5c6Ee304399DBdB9C8Ef030aB642B10820DB8F56",
        symbol: "B-80BAL-20WETH",
      },
      {
        address: "0x616e8BfA43F920657B3497DBf40D6b1A02D4608d",
        symbol: "auraBAL",
      },
    ],
  },
  {
    bpt: "0x3de27EFa2F1AA663Ae5D458857e731c129069F29",
    id: "0x3de27efa2f1aa663ae5d458857e731c129069f29000200000000000000000588",
    name: "20wstETH-80AAVE",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
        symbol: "wstETH",
      },
      {
        address: "0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9",
        symbol: "AAVE",
      },
    ],
  },
  {
    bpt: "0x3E09E828c716c5e2BC5034EeD7d5eC8677ffba18",
    id: "0x3e09e828c716c5e2bc5034eed7d5ec8677ffba180002000000000000000002b1",
    name: "80MPH-20WETH",
    type: "Weighted",
    gauge: "0x1a2DC832188327e0C59F6801d79b8C5c395161BC",
    tokens: [
      {
        address: "0x8888801aF4d980682e47f1A9036e589479e835C5",
        symbol: "MPH",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x3e5FA9518eA95c3E533EB377C001702A9AaCAA32",
    id: "0x3e5fa9518ea95c3e533eb377c001702a9aacaa32000200000000000000000052",
    name: "B-50WETH-50USDT",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
        symbol: "USDT",
      },
    ],
  },
  {
    bpt: "0x3ebf48cd7586d7A4521cE59E53D9a907EBf1480F",
    id: "0x3ebf48cd7586d7a4521ce59e53d9a907ebf1480f000200000000000000000028",
    name: "B-50BAL-50WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xba100000625a3754423978a60c9317c58a424e3D",
        symbol: "BAL",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x3f725ED5791b72554E9BEDf461eb76fC72dB8834",
    id: "0x3f725ed5791b72554e9bedf461eb76fc72db883400020000000000000000017a",
    name: "50QUA-50USDT",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x4dAeb4a06F70f4b1A5C329115731fE4b89C0B227",
        symbol: "QUA",
      },
      {
        address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
        symbol: "USDT",
      },
    ],
  },
  {
    bpt: "0x3F7C10701b14197E2695dEC6428a2Ca4Cf7FC3B8",
    id: "0x3f7c10701b14197e2695dec6428a2ca4cf7fc3b800020000000000000000023c",
    name: "50DFX-50WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x888888435FDe8e7d4c54cAb67f206e4199454c60",
        symbol: "DFX",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x3FA8C89704e5d07565444009e5d9e624B40Be813",
    id: "0x3fa8c89704e5d07565444009e5d9e624b40be813000000000000000000000599",
    name: "GHO/LUSD",
    type: "ComposableStable",
    gauge: null,
    tokens: [
      {
        address: "0x40D16FC0246aD3160Ccc09B8D0D3A2cD28aE6C2f",
        symbol: "GHO",
      },
      {
        address: "0x5f98805A4E8be255a32880FDeC7F6728C6568bA0",
        symbol: "LUSD",
      },
    ],
  },
  {
    bpt: "0x3ff3a210e57cFe679D9AD1e9bA6453A716C56a2e",
    id: "0x3ff3a210e57cfe679d9ad1e9ba6453a716c56a2e0002000000000000000005d5",
    name: "STG/USDC",
    type: "Weighted",
    gauge: "0x15C84754c7445D0DF6c613f1490cA07654347c1B",
    tokens: [
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
      {
        address: "0xAf5191B0De278C7286d6C7CC6ab6BB8A73bA2Cd6",
        symbol: "STG",
      },
    ],
  },
  {
    bpt: "0x41FDbea2E52790c0a1Dc374F07b628741f2E062D",
    id: "0x41fdbea2e52790c0a1dc374f07b628741f2e062d0002000000000000000006be",
    name: "ECLP-stdeUSD-deUSD",
    type: "GyroE",
    gauge: "0xA00DB7d9c465e95e4AA814A9340B9A161364470a",
    tokens: [
      {
        address: "0x15700B564Ca08D9439C58cA5053166E8317aa138",
        symbol: "deUSD",
      },
      {
        address: "0x5C5b196aBE0d54485975D1Ec29617D42D9198326",
        symbol: "sdeUSD",
      },
    ],
  },
  {
    bpt: "0x42FBD9F666AaCC0026ca1B88C94259519e03dd67",
    id: "0x42fbd9f666aacc0026ca1b88c94259519e03dd67000200000000000000000507",
    name: "50COIL-50USDC",
    type: "Weighted",
    gauge: "0x78a54C8F4eAba82e45cBC20B9454a83CB296e09E",
    tokens: [
      {
        address: "0x823E1B82cE1Dc147Bbdb25a203f046aFab1CE918",
        symbol: "COIL",
      },
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0x441b8a1980f2F2E43A9397099d15CC2Fe6D36250",
    id: "0x441b8a1980f2f2e43a9397099d15cc2fe6d3625000020000000000000000035f",
    name: "50INV-50DOLA",
    type: "Weighted",
    gauge: "0x422CF6D2cBa89b8D0af259e508Ffd6AddA1d821a",
    tokens: [
      {
        address: "0x41D5D79431A913C4aE7d69a668ecdfE5fF9DFB68",
        symbol: "INV",
      },
      {
        address: "0x865377367054516e17014CcdED1e7d814EDC9ce4",
        symbol: "DOLA",
      },
    ],
  },
  {
    bpt: "0x4446d101E91D042b5d08b62fdE126E307F1aCD57",
    id: "0x4446d101e91d042b5d08b62fde126e307f1acd570002000000000000000006f9",
    name: "80VLR/20WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x4e107a0000DB66f0E9Fd2039288Bf811dD1f9c74",
        symbol: "VLR",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x4626d81b3a1711bEb79f4CEcFf2413886d461677",
    id: "0x4626d81b3a1711beb79f4cecff2413886d461677000200000000000000000011",
    name: "B-50BAL-50DAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
        symbol: "DAI",
      },
      {
        address: "0xba100000625a3754423978a60c9317c58a424e3D",
        symbol: "BAL",
      },
    ],
  },
  {
    bpt: "0x470581ca95C071728e85a6E28a5b1754cD489bE2",
    id: "0x470581ca95c071728e85a6e28a5b1754cd489be200020000000000000000063c",
    name: "50OCEAN-50WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x967da4048cD07aB37855c090aAF366e4ce1b9F48",
        symbol: "OCEAN",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x4729F67394030472e853cb61954fe784BFB36c3B",
    id: "0x4729f67394030472e853cb61954fe784bfb36c3b000100000000000000000569",
    name: "25WBTC-50USDC-25WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
        symbol: "WBTC",
      },
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x472AFe4C35dC218A41736D4aceEaB650db43C584",
    id: "0x472afe4c35dc218a41736d4aceeab650db43c58400020000000000000000034f",
    name: "80PHONON-20WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x758B4684BE769E92eeFeA93f60DDA0181eA303Ec",
        symbol: "PHONON",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x47E1Cf97A0586367349A14306A65F54Ba0b8f1B6",
    id: "0x47e1cf97a0586367349a14306a65f54ba0b8f1b60002000000000000000005cd",
    name: "20WETH-80ALTR",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xD1ffCacFc630CE68d3cd3369F5db829a3ed01fE2",
        symbol: "ALTR",
      },
    ],
  },
  {
    bpt: "0x48607651416A943bF5AC71C41BE1420538e78f87",
    id: "0x48607651416a943bf5ac71c41be1420538e78f87000200000000000000000327",
    name: "50Silo-50WETH",
    type: "Weighted",
    gauge: "0xC545aa66cdd9Cf172568dC8ebFdDa1CE9a60e0CB",
    tokens: [
      {
        address: "0x6f80310CA7F2C654691D1383149Fa1A57d8AB1f8",
        symbol: "Silo",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x494B26D4aEE801Cb1fabF498Ee24f0af20238743",
    id: "0x494b26d4aee801cb1fabf498ee24f0af20238743000200000000000000000083",
    name: "FOURWP",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x4730fB1463A6F1F44AEB45F6c5c422427f37F4D0",
        symbol: "FOUR",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x4aA462D59361fC0115B3aB7E447627534a8642ae",
    id: "0x4aa462d59361fc0115b3ab7e447627534a8642ae000100000000000000000158",
    name: "25PAXG-50USDC-25WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x45804880De22913dAFE09f4980848ECE6EcbAf78",
        symbol: "PAXG",
      },
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x4dA83bbE43235d600b914Ec3dbdE8B2EAA801869",
    id: "0x4da83bbe43235d600b914ec3dbde8b2eaa801869000200000000000000000614",
    name: "NOVA-WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x562dE17D35e3B3389ceF3BF02424EDaD14e328F7",
        symbol: "NOVA",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x4E1325FF075a387e3D337f5f12638d6D72B12780",
    id: "0x4e1325ff075a387e3d337f5f12638d6d72b127800001000000000000000006d7",
    name: "25OLAS-25WBTC-25DAI-25WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x0001A500A6B18995B03f44bb040A5fFc28E45CB0",
        symbol: "OLAS",
      },
      {
        address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
        symbol: "WBTC",
      },
      {
        address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
        symbol: "DAI",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x4f883B5C0C01Fe13CeDd05c684f00266b0626e23",
    id: "0x4f883b5c0c01fe13cedd05c684f00266b0626e230002000000000000000006ad",
    name: "80wDAG-20USDC",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x2E3CFE45E3EE7C017277f22e35d2f29edC99d570",
        symbol: "wDAG",
      },
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0x5002EB99f569405987d56e53Cec01FbB5DA28968",
    id: "0x5002eb99f569405987d56e53cec01fbb5da28968000200000000000000000696",
    name: "50WAR-50WETH",
    type: "Weighted",
    gauge: "0x7152d543177fd720BC8EC14891c072BCc6f8218b",
    tokens: [
      {
        address: "0xa8258deE2a677874a48F5320670A869D74f0cbC1",
        symbol: "WAR",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x5122E01D819E58BB2E22528c0D68D310f0AA6FD7",
    id: "0x5122e01d819e58bb2e22528c0d68d310f0aa6fd7000200000000000000000163",
    name: "sNOTE-BPT",
    type: "Weighted",
    gauge: "0x09AFEc27F5A6201617aAd014CeEa8deb572B0608",
    tokens: [
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xCFEAead4947f0705A14ec42aC3D44129E1Ef3eD5",
        symbol: "NOTE",
      },
    ],
  },
  {
    bpt: "0x514f35a92A13bc7093f299AF5D8ebb1387E42D6B",
    id: "0x514f35a92a13bc7093f299af5d8ebb1387e42d6b0002000000000000000000c9",
    name: "B-80TEMP-20WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xA36FDBBAE3c9d55a1d67EE5821d53B50B63A1aB9",
        symbol: "TEMP",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x51735bdFBFE3fC13dEa8DC6502E2E95898942961",
    id: "0x51735bdfbfe3fc13dea8dc6502e2e958989429610002000000000000000000a0",
    name: "B-80UNN-20WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x226f7b842E0F0120b7E194D05432b3fd14773a9D",
        symbol: "UNN",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x517390b2B806cb62f20ad340DE6d98B2A8F17F2B",
    id: "0x517390b2b806cb62f20ad340de6d98b2a8f17f2b0002000000000000000001ba",
    name: "20WETH-80ELIMU",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xe29797910D413281d2821D5d9a989262c8121CC2",
        symbol: "ELIMU",
      },
    ],
  },
  {
    bpt: "0x5512A4bbe7B3051f92324bAcF25C02b9000c4a50",
    id: "0x5512a4bbe7b3051f92324bacf25c02b9000c4a500001000000000000000003d7",
    name: "33LUSD-33LQTY-33WETH",
    type: "Weighted",
    gauge: "0x9Cc382125f19539EcEB2f607A57bBcac459cb097",
    tokens: [
      {
        address: "0x5f98805A4E8be255a32880FDeC7F6728C6568bA0",
        symbol: "LUSD",
      },
      {
        address: "0x6DEA81C8171D0bA574754EF6F8b412F2Ed88c54D",
        symbol: "LQTY",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x57766212638c425e9CB0C6D6e1683dda369C0FFF",
    id: "0x57766212638c425e9cb0c6d6e1683dda369c0fff000200000000000000000678",
    name: "80GEM-20WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x0447D3454b25935eeD47F65b4Bd22b9b23bE326a",
        symbol: "GEM",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x577A7f7EE659Aa14Dc16FD384B3F8078E23F1920",
    id: "0x577a7f7ee659aa14dc16fd384b3f8078e23f1920000200000000000000000633",
    name: "BAL-20WETH-80VCX",
    type: "Weighted",
    gauge: "0xf593c50A3a3e1294b6E3c089cEC44021BdD43Fa7",
    tokens: [
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xcE246eEa10988C495B4A90a905Ee9237a0f91543",
        symbol: "VCX",
      },
    ],
  },
  {
    bpt: "0x5Aa90c7362ea46b3cbFBD7F01EA5Ca69C98Fef1c",
    id: "0x5aa90c7362ea46b3cbfbd7f01ea5ca69c98fef1c000200000000000000000020",
    name: "B-50UNI-50WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984",
        symbol: "UNI",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x5b1C06c4923DBBa4B27Cfa270FFB2E60Aa286159",
    id: "0x5b1c06c4923dbba4b27cfa270ffb2e60aa28615900020000000000000000004a",
    name: "PAR75-MIMO25",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x68037790A0229e9Ce6EaA8A99ea92964106C4703",
        symbol: "PAR",
      },
      {
        address: "0x90B831fa3Bebf58E9744A14D638E25B4eE06f9Bc",
        symbol: "MIMO",
      },
    ],
  },
  {
    bpt: "0x5c6Ee304399DBdB9C8Ef030aB642B10820DB8F56",
    id: "0x5c6ee304399dbdb9c8ef030ab642b10820db8f56000200000000000000000014",
    name: "B-80BAL-20WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xba100000625a3754423978a60c9317c58a424e3D",
        symbol: "BAL",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x5D563Ca1E2daaAe3402c36097b934630AB53702c",
    id: "0x5d563ca1e2daaae3402c36097b934630ab53702c000200000000000000000024",
    name: "B-50WETH-50mUSD",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xe2f2a5C287993345a840Db3B0845fbC70f5935a5",
        symbol: "mUSD",
      },
    ],
  },
  {
    bpt: "0x5d6e3d7632D6719e04cA162be652164Bec1EaA6b",
    id: "0x5d6e3d7632d6719e04ca162be652164bec1eaa6b000200000000000000000048",
    name: "PAR50-USDC50",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x68037790A0229e9Ce6EaA8A99ea92964106C4703",
        symbol: "PAR",
      },
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0x5E6989c0E2B6600aB585D56Bf05479d5450a60C8",
    id: "0x5e6989c0e2b6600ab585d56bf05479d5450a60c80002000000000000000000c1",
    name: "B-80NEXO-20WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xB62132e35a6c13ee1EE0f84dC5d40bad8d815206",
        symbol: "NEXO",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x5f1f4E50ba51D723F12385a8a9606afc3A0555f5",
    id: "0x5f1f4e50ba51d723f12385a8a9606afc3a0555f5000200000000000000000465",
    name: "50wstETH-50LDO",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x5A98FcBEA516Cf06857215779Fd812CA3beF1B32",
        symbol: "LDO",
      },
      {
        address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
        symbol: "wstETH",
      },
    ],
  },
  {
    bpt: "0x5f7FA48d765053F8dD85E052843e12D23e3D7BC5",
    id: "0x5f7fa48d765053f8dd85e052843e12d23e3d7bc50002000000000000000000c0",
    name: "NWWP",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xCFEAead4947f0705A14ec42aC3D44129E1Ef3eD5",
        symbol: "NOTE",
      },
    ],
  },
  {
    bpt: "0x6055689F452d2f9D86945F3597e1D47EE819254D",
    id: "0x6055689f452d2f9d86945f3597e1d47ee819254d000200000000000000000640",
    name: "50mkUSD-50PRISMA",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x4591DBfF62656E7859Afe5e45f6f47D3669fBB28",
        symbol: "mkUSD",
      },
      {
        address: "0xdA47862a83dac0c112BA89c6abC2159b95afd71C",
        symbol: "PRISMA",
      },
    ],
  },
  {
    bpt: "0x60B4601cDdDc4467f31b1F770cb93c51dC7dC728",
    id: "0x60b4601cdddc4467f31b1f770cb93c51dc7dc728000200000000000000000042",
    name: "50PIXEL-50WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x89045d0Af6A12782Ec6f701eE6698bEaF17d0eA2",
        symbol: "PIXEL",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x616D4D131F1147aC3B3C3CC752BAB8613395B2bB",
    id: "0x616d4d131f1147ac3b3c3cc752bab8613395b2bb000200000000000000000584",
    name: "B-yBAL-STABLE",
    type: "Stable",
    gauge: null,
    tokens: [
      {
        address: "0x5c6Ee304399DBdB9C8Ef030aB642B10820DB8F56",
        symbol: "B-80BAL-20WETH",
      },
      {
        address: "0x98E86Ed5b0E48734430BfBe92101156C75418cad",
        symbol: "yBAL",
      },
    ],
  },
  {
    bpt: "0x61d5dc44849c9C87b0856a2a311536205C96c7FD",
    id: "0x61d5dc44849c9c87b0856a2a311536205c96c7fd000100000000000000000001",
    name: "BED",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x1494CA1F11D487c2bBe4543E90080AeBa4BA3C2b",
        symbol: "DPI",
      },
      {
        address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
        symbol: "WBTC",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x6228f64D5BA8376652Bfe7E36569D595347cF6Fb",
    id: "0x6228f64d5ba8376652bfe7e36569d595347cf6fb0002000000000000000005df",
    name: "80T-20TBTC",
    type: "Weighted",
    gauge: "0xCc6A23446f6388D78F3037BD55f2eB820352d982",
    tokens: [
      {
        address: "0x18084fbA666a33d37592fA2633fD49a74DD93a88",
        symbol: "tBTC",
      },
      {
        address: "0xCdF7028ceAB81fA0C6971208e83fa7872994beE5",
        symbol: "T",
      },
    ],
  },
  {
    bpt: "0x62E57e37E3185871c13a422A363293780D17305B",
    id: "0x62e57e37e3185871c13a422a363293780d17305b0002000000000000000006d3",
    name: "B-kaiAURA-AURA-WEIGHTED",
    type: "Weighted",
    gauge: "0x4fd03B8C15E70E6b3413E4D2ff3825a19746e78B",
    tokens: [
      {
        address: "0xC0c293ce456fF0ED870ADd98a0828Dd4d2903DBF",
        symbol: "AURA",
      },
      {
        address: "0xFFd9c960bC303b8d3aAED58229ce8a7310bCc5b8",
        symbol: "kaiAURA",
      },
    ],
  },
  {
    bpt: "0x63FC054159094583a27632361BD11C94c30e48C7",
    id: "0x63fc054159094583a27632361bd11c94c30e48c70002000000000000000006f7",
    name: "ECLP-WETH-USDT-dyn",
    type: "GyroE",
    gauge: "0x48daBb17918C2eb360F5F05F44bAAd6c37C27BF5",
    tokens: [
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
        symbol: "USDT",
      },
    ],
  },
  {
    bpt: "0x67b532d47A31CE1eD0800E6913dbf5F6e9C48a18",
    id: "0x67b532d47a31ce1ed0800e6913dbf5f6e9c48a180002000000000000000000c5",
    name: "⚗️_WEIGHTED",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x88ACDd2a6425c3FaAE4Bc9650Fd7E27e0Bebb7aB",
        symbol: "⚗️",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x6803C821Dac9b61026b3F4aF0FcF46229361D551",
    id: "0x6803c821dac9b61026b3f4af0fcf46229361d5510002000000000000000003ad",
    name: "25CLV-75stETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x80C62FE4487E1351b47Ba49809EBD60ED085bf52",
        symbol: "CLV",
      },
      {
        address: "0xae7ab96520DE3A18E5e111B5EaAb095312D7fE84",
        symbol: "stETH",
      },
    ],
  },
  {
    bpt: "0x68454578f7017bA0C0c5bD1091975d7a7F3001c8",
    id: "0x68454578f7017ba0c0c5bd1091975d7a7f3001c800020000000000000000025e",
    name: "33DAI-33USDC-33LEVEN",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
      {
        address: "0xA415e9E13820cb373E40B6994D8a10E97356F917",
        symbol: "LEVEN",
      },
    ],
  },
  {
    bpt: "0x6873789A71b18eFa98a8E8758A5EA456D70c178f",
    id: "0x6873789a71b18efa98a8e8758a5ea456d70c178f0002000000000000000006c6",
    name: "50GIV-50FOX",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x900dB999074d9277c5DA2A43F252D74366230DA0",
        symbol: "GIV",
      },
      {
        address: "0xc770EEfAd204B5180dF6a14Ee197D99d808ee52d",
        symbol: "FOX",
      },
    ],
  },
  {
    bpt: "0x68e3266C9C8bbD44ad9Dca5AFBfe629022AeE9fE",
    id: "0x68e3266c9c8bbd44ad9dca5afbfe629022aee9fe000200000000000000000512",
    name: "B-wjAura-wETH",
    type: "Weighted",
    gauge: "0x2D42910D826e5500579D121596E98A6eb33C0a1b",
    tokens: [
      {
        address: "0x198d7387Fa97A73F05b8578CdEFf8F2A1f34Cd1F",
        symbol: "wjAURA",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x6987633f18Ca0B4a10831331FcC57211941B6bA0",
    id: "0x6987633f18ca0b4a10831331fcc57211941b6ba0000200000000000000000530",
    name: "20AGI-80WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x5F18ea482ad5cc6BC65803817C99f477043DcE85",
        symbol: "AGI",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x6Ae5a7857aAd26722cB02CC168e38c52E0e4e45d",
    id: "0x6ae5a7857aad26722cb02cc168e38c52e0e4e45d0000000000000000000005dd",
    name: "TBY-feb1924-USDC-BPT",
    type: "ComposableStable",
    gauge: null,
    tokens: [
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
      {
        address: "0xC4cafEFBc3dfeA629c589728d648CB6111DB3136",
        symbol: "TBY-feb1924",
      },
    ],
  },
  {
    bpt: "0x6AE82385f76e3742f89cB46343B169f6ee49dE1b",
    id: "0x6ae82385f76e3742f89cb46343b169f6ee49de1b000200000000000000000016",
    name: "B-80TEL-20WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x467Bccd9d29f223BcE8043b84E8C8B282827790F",
        symbol: "TEL",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x6b0D50a9df06006170e2d11D468cbFe0f58B43e2",
    id: "0x6b0d50a9df06006170e2d11d468cbfe0f58b43e2000100000000000000000361",
    name: "25LINK-25AAVE-25MKR-25AMPL",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x514910771AF9Ca656af840dff83E8264EcF986CA",
        symbol: "LINK",
      },
      {
        address: "0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9",
        symbol: "AAVE",
      },
      {
        address: "0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2",
        symbol: "MKR",
      },
      {
        address: "0xD46bA6D942050d489DBd938a2C909A5d5039A161",
        symbol: "AMPL",
      },
    ],
  },
  {
    bpt: "0x6DfE1f148Da882dDf00A365a9aE86ec2484207c0",
    id: "0x6dfe1f148da882ddf00a365a9ae86ec2484207c00002000000000000000006db",
    name: "50PAXG-50XAUt",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x45804880De22913dAFE09f4980848ECE6EcbAf78",
        symbol: "PAXG",
      },
      {
        address: "0x68749665FF8D2d112Fa859AA293F07A622782F38",
        symbol: "XAUt",
      },
    ],
  },
  {
    bpt: "0x6E5ba97e42e4Bd036a9b785DB964DC8AAD1c699d",
    id: "0x6e5ba97e42e4bd036a9b785db964dc8aad1c699d0002000000000000000005b5",
    name: "50USDC-50USDT",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
      {
        address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
        symbol: "USDT",
      },
    ],
  },
  {
    bpt: "0x6f0ed6f346007563D3266DE350d174a831bDE0ca",
    id: "0x6f0ed6f346007563d3266de350d174a831bde0ca0001000000000000000005db",
    name: "50KNC-25WETH-25USDC-BPT",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xdeFA4e8a7bcBA345F687a2f1456F5Edd9CE97202",
        symbol: "KNC",
      },
    ],
  },
  {
    bpt: "0x6f4906c181e6aCb096908238c5ffD088cca6Ba9f",
    id: "0x6f4906c181e6acb096908238c5ffd088cca6ba9f00020000000000000000053a",
    name: "CPEPE",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x6982508145454Ce325dDbE47a25d4ec3d2311933",
        symbol: "PEPE",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x702605F43471183158938C1a3e5f5A359d7b31ba",
    id: "0x702605f43471183158938c1a3e5f5a359d7b31ba00020000000000000000009f",
    name: "B-80BAL-20WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x3Ec8798B81485A254928B70CDA1cf0A2BB0B74D7",
        symbol: "GRO",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x7173b184525feAD2fFbde5FBe6FCB65Ea8246eE7",
    id: "0x7173b184525fead2ffbde5fbe6fcb65ea8246ee70002000000000000000000c7",
    name: "LPeYyvUSDC-29APR22",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x29Cca1dbA3f2DB3C2708608d2676ff8044c14073",
        symbol: "eYyvUSDC-29APR22",
      },
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0x759FABc513AccD292ADA967C4DD7Bb94Da39232e",
    id: "0x759fabc513accd292ada967c4dd7bb94da39232e0002000000000000000005a8",
    name: "80RATE/20WETH-BPT",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x695BD8b642342d792a34392bEa1461b98895300B",
        symbol: "RATE",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x76FCf0e8C7Ff37A47a799FA2cd4c13cDe0D981C9",
    id: "0x76fcf0e8c7ff37a47a799fa2cd4c13cde0d981c90002000000000000000003d2",
    name: "50OHM-50DAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x64aa3364F17a4D01c6f1751Fd97C2BD3D7e7f1D5",
        symbol: "OHM",
      },
      {
        address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
        symbol: "DAI",
      },
    ],
  },
  {
    bpt: "0x771fBbfcBD8BA252f7f1ee47c1A486BDB0b5bC62",
    id: "0x771fbbfcbd8ba252f7f1ee47c1a486bdb0b5bc6200020000000000000000063d",
    name: "50RSR-50WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x320623b8E4fF03373931769A31Fc52A4E78B5d70",
        symbol: "RSR",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x77952E11E1ba727FfceA95a0f38Ed7DA586EeBc7",
    id: "0x77952e11e1ba727ffcea95a0f38ed7da586eebc7000200000000000000000116",
    name: "MTRL-ETH Liquidity Pool",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x13C99770694f07279607A6274F28a28c33086424",
        symbol: "MTRL",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x77B692C5ca2CCEaeeF4dcC959D6C3bD919710B66",
    id: "0x77b692c5ca2cceaeef4dcc959d6c3bd919710b6600020000000000000000055e",
    name: "80BREWSKI-20USDC",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x9E3c6575f674BdeE85731d23259971Aa6ddA7b9b",
        symbol: "BREWSKI",
      },
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0x7819f1532c49388106f7762328c51eE70EdD134c",
    id: "0x7819f1532c49388106f7762328c51ee70edd134c000200000000000000000109",
    name: "80GIV-20WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x900dB999074d9277c5DA2A43F252D74366230DA0",
        symbol: "GIV",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x79c58f70905F734641735BC61e45c19dD9Ad60bC",
    id: "0x79c58f70905f734641735bc61e45c19dd9ad60bc0000000000000000000004e7",
    name: "USDC-DAI-USDT",
    type: "ComposableStable",
    gauge: null,
    tokens: [
      {
        address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
        symbol: "DAI",
      },
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
      {
        address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
        symbol: "USDT",
      },
    ],
  },
  {
    bpt: "0x7C9cF12d783821d5C63d8E9427aF5C44bAd92445",
    id: "0x7c9cf12d783821d5c63d8e9427af5c44bad924450002000000000000000000b4",
    name: "LPeYyvUSDC-17DEC21",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x33Dde19C163cDccE4E5a81f04a2Af561b9Ef58d7",
        symbol: "eYyvUSDC-17DEC21",
      },
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0x7cB1756E25c41EB921b2c9039f1f368f85e46995",
    id: "0x7cb1756e25c41eb921b2c9039f1f368f85e469950002000000000000000006e8",
    name: "NETETH",
    type: "Weighted",
    gauge: "0x76a6d2A59D3524cFA6775465341a19ca0d5a8657",
    tokens: [
      {
        address: "0x6e6B7ADfC7Db9fEeB8896418aC3422966f65D0A5",
        symbol: "NET",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x7EB878107Af0440F9E776f999CE053D277c8Aca8",
    id: "0x7eb878107af0440f9e776f999ce053d277c8aca8000200000000000000000012",
    name: "B-70AST-30WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x27054b13b1B798B345b591a4d22e6562d47eA75a",
        symbol: "AST",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x80bE0c303D8Ad2A280878b50a39B1ee8E54DBD22",
    id: "0x80be0c303d8ad2a280878b50a39b1ee8e54dbd2200020000000000000000000f",
    name: "B-50LPT-50WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x58b6A8A3302369DAEc383334672404Ee733aB239",
        symbol: "LPT",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x813E6A5f31C95F7c5f9982B1FDc6C69610bEab4A",
    id: "0x813e6a5f31c95f7c5f9982b1fdc6c69610beab4a0002000000000000000003ed",
    name: "50WETH-50CRV",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xD533a949740bb3306d119CC777fa900bA034cd52",
        symbol: "CRV",
      },
    ],
  },
  {
    bpt: "0x8167A1117691f39e05e9131cfA88F0e3A620E967",
    id: "0x8167a1117691f39e05e9131cfa88f0e3a620e96700020000000000000000038c",
    name: "20WETH-80T",
    type: "Weighted",
    gauge: "0x7Fc115BF013844D6eF988837F7ae6398af153532",
    tokens: [
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xCdF7028ceAB81fA0C6971208e83fa7872994beE5",
        symbol: "T",
      },
    ],
  },
  {
    bpt: "0x82b8c7c6Fb62D09CfD004309c1F353FB1A926Edc",
    id: "0x82b8c7c6fb62d09cfd004309c1f353fb1a926edc000200000000000000000626",
    name: "EPOCH-LP",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x97D0CfEB4FdE54B430307c9482d6f79C761Fe9B6",
        symbol: "EPOCH",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x82e80Ce9D4890BAF288B70aC548Aa256599Bf044",
    id: "0x82e80ce9d4890baf288b70ac548aa256599bf044000200000000000000000619",
    name: "80mevETH-20FOLD",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x24Ae2dA0f361AA4BE46b48EB19C91e02c5e4f27E",
        symbol: "mevETH",
      },
      {
        address: "0xd084944d3c05CD115C09d072B9F44bA3E0E45921",
        symbol: "FOLD",
      },
    ],
  },
  {
    bpt: "0x8334215586e93EE85E3f1a281eAF66e52015754D",
    id: "0x8334215586e93ee85e3f1a281eaf66e52015754d00020000000000000000057e",
    name: "50WETH-50FIEF",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xeA068Fba19CE95f12d252aD8Cb2939225C4Ea02D",
        symbol: "FIEF",
      },
    ],
  },
  {
    bpt: "0x8353157092ED8Be69a9DF8F95af097bbF33Cb2aF",
    id: "0x8353157092ed8be69a9df8f95af097bbf33cb2af0000000000000000000005d9",
    name: "GHO/USDT/USDC",
    type: "ComposableStable",
    gauge: null,
    tokens: [
      {
        address: "0x40D16FC0246aD3160Ccc09B8D0D3A2cD28aE6C2f",
        symbol: "GHO",
      },
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
      {
        address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
        symbol: "USDT",
      },
    ],
  },
  {
    bpt: "0x8405DC5Ed3789fDBEc5A7f9366b977cB0B023F9f",
    id: "0x8405dc5ed3789fdbec5a7f9366b977cb0b023f9f0002000000000000000002b7",
    name: "20USDC-80FLOAT",
    type: "Weighted",
    gauge: "0x9D5d7CF33758f92Fb0F79B7b4A90EFF37ba7f505",
    tokens: [
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
      {
        address: "0xb05097849BCA421A3f51B249BA6CCa4aF4b97cb9",
        symbol: "FLOAT",
      },
    ],
  },
  {
    bpt: "0x844Ba71D4902Ed3dE091112951b9c4B4D25A09DD",
    id: "0x844ba71d4902ed3de091112951b9c4b4d25a09dd00020000000000000000014b",
    name: "Balancer 90 EEFI 10 WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x92915c346287DdFbcEc8f86c8EB52280eD05b3A3",
        symbol: "EEFI",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x8461537a9BfC5A1dF57cF825F8A58049eF61557B",
    id: "0x8461537a9bfc5a1df57cf825f8a58049ef61557b0002000000000000000006ea",
    name: "ECLP-USR-GYD",
    type: "GyroE",
    gauge: null,
    tokens: [
      {
        address: "0x66a1E37c9b0eAddca17d3662D6c05F4DECf3e110",
        symbol: "USR",
      },
      {
        address: "0xe07F9D810a48ab5c3c914BA3cA53AF14E4491e8A",
        symbol: "GYD",
      },
    ],
  },
  {
    bpt: "0x848a5564158d84b8A8fb68ab5D004Fae11619A54",
    id: "0x848a5564158d84b8a8fb68ab5d004fae11619a5400000000000000000000066a",
    name: "weETH/ezETH/rswETH",
    type: "ComposableStable",
    gauge: null,
    tokens: [
      {
        address: "0xbf5495Efe5DB9ce00f80364C8B423567e58d2110",
        symbol: "ezETH",
      },
      {
        address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
        symbol: "weETH",
      },
      {
        address: "0xFAe103DC9cf190eD75350761e95403b7b8aFa6c0",
        symbol: "rswETH",
      },
    ],
  },
  {
    bpt: "0x851523A36690bF267BbFEC389C823072D82921a9",
    id: "0x851523a36690bf267bbfec389c823072d82921a90002000000000000000001ed",
    name: "B-wstETH-STABLE-C",
    type: "MetaStable",
    gauge: "0x506501C3f21656187Af8Fe247e8Eb113976C4969",
    tokens: [
      {
        address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
        symbol: "wstETH",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x85370D9e3bb111391cc89F6DE344E80176046183",
    id: "0x85370d9e3bb111391cc89f6de344e801760461830002000000000000000001ef",
    name: "CREAM_ETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x2ba592F78dB6436527729929AAf6c908497cB200",
        symbol: "CREAM",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x87165B659Ba7746907a48763063efA3B323C2B07",
    id: "0x87165b659ba7746907a48763063efa3b323c2b0700020000000000000000002d",
    name: "80BANK-20WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x2d94AA3e47d9D5024503Ca8491fcE9A2fB4DA198",
        symbol: "BANK",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x87a867f5D240a782d43D90b6B06DEa470F3f8F22",
    id: "0x87a867f5d240a782d43d90b6b06dea470f3f8f22000200000000000000000516",
    name: "B-50COMP-50wstETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
        symbol: "wstETH",
      },
      {
        address: "0xc00e94Cb662C3520282E6f5717214004A7f26888",
        symbol: "COMP",
      },
    ],
  },
  {
    bpt: "0x87Cf784Ee055d0260AD3AB7EE40888D4a0A5d364",
    id: "0x87cf784ee055d0260ad3ab7ee40888d4a0a5d364000200000000000000000691",
    name: "50ZRS-50WETH-BPT",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x75e88B8c2d34a52a6d36deAda664D7dc9116e4EF",
        symbol: "ZRS",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x88794C65550DeB6b4087B7552eCf295113794410",
    id: "0x88794c65550deb6b4087b7552ecf295113794410000000000000000000000648",
    name: "pxETH/wETH",
    type: "ComposableStable",
    gauge: "0xdee29b7b6dF3576280bFBbC088ee9eBAA767C0Bd",
    tokens: [
      {
        address: "0x04C154b66CB340F3Ae24111CC767e0184Ed00Cc6",
        symbol: "pxETH",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x8A34b5ad76F528bfEc06c80D85EF3b53dA7FC300",
    id: "0x8a34b5ad76f528bfec06c80d85ef3b53da7fc30000020000000000000000043e",
    name: "B-ankrETH-WETH-Stable",
    type: "MetaStable",
    gauge: null,
    tokens: [
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xE95A203B1a91a908F9B9CE46459d101078c2c3cb",
        symbol: "ankrETH",
      },
    ],
  },
  {
    bpt: "0x8AE511Baa25D6c7d21F45ebE60Ff29912D28A8E6",
    id: "0x8ae511baa25d6c7d21f45ebe60ff29912d28a8e60002000000000000000003d4",
    name: "50AAVE-50WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9",
        symbol: "AAVE",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x8Bd4A1E74A27182D23B98c10Fd21D4FbB0eD4BA0",
    id: "0x8bd4a1e74a27182d23b98c10fd21d4fbb0ed4ba00002000000000000000004ed",
    name: "50TEMPLE-50DAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x470EBf5f030Ed85Fc1ed4C2d36B9DD02e77CF1b7",
        symbol: "TEMPLE",
      },
      {
        address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
        symbol: "DAI",
      },
    ],
  },
  {
    bpt: "0x8D93B853849b9884E2Bb413444Ec23eB5366eE91",
    id: "0x8d93b853849b9884e2bb413444ec23eb5366ee910002000000000000000006b3",
    name: "ECLP-sUSDe-GYD",
    type: "GyroE",
    gauge: "0x146b6030E6d6a6398B918E9854652a71C9537180",
    tokens: [
      {
        address: "0x9D39A5DE30e57443BfF2A8307A4256c8797A3497",
        symbol: "sUSDe",
      },
      {
        address: "0xe07F9D810a48ab5c3c914BA3cA53AF14E4491e8A",
        symbol: "GYD",
      },
    ],
  },
  {
    bpt: "0x8DD7b0C76Ae83bCcE1B5510cCEb7DceC8b40087c",
    id: "0x8dd7b0c76ae83bcce1b5510cceb7dcec8b40087c0002000000000000000002bd",
    name: "50BANK-50WETH",
    type: "Weighted",
    gauge: "0x9795B9f02984cb9a09E03FB975b1D4285CEd80Fe",
    tokens: [
      {
        address: "0x24A6A37576377F63f194Caa5F518a60f45b42921",
        symbol: "BANK",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x8e6C196e201942246Cef85718C5D3a5622518053",
    id: "0x8e6c196e201942246cef85718c5d3a5622518053000200000000000000000582",
    name: "B-80LE-20WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x219A56e6056c6e72005bDA1F967aF5D626Af4501",
        symbol: "LE",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x8e9690E135005E415BD050B11768615DE43fe5f8",
    id: "0x8e9690e135005e415bd050b11768615de43fe5f8000200000000000000000043",
    name: "50STR-50WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x11C1a6B3Ed6Bb362954b29d3183cfA97A0c806Aa",
        symbol: "STR",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x8eB6c82C3081bBBd45DcAC5afA631aaC53478b7C",
    id: "0x8eb6c82c3081bbbd45dcac5afa631aac53478b7c000100000000000000000270",
    name: "40WBTC-40DIGG-20graviAURA",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
        symbol: "WBTC",
      },
      {
        address: "0x798D1bE841a82a273720CE31c822C61a67a601C3",
        symbol: "DIGG",
      },
      {
        address: "0xBA485b556399123261a5F9c95d413B4f93107407",
        symbol: "graviAURA",
      },
    ],
  },
  {
    bpt: "0x8f4205e1604133d1875a3E771AE7e4F2b0865639",
    id: "0x8f4205e1604133d1875a3e771ae7e4f2b086563900020000000000000000010e",
    name: "50N/A-50N/A",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x43D4A3cd90ddD2F8f4f693170C9c8098163502ad",
        symbol: "D2D",
      },
      {
        address: "0xba100000625a3754423978a60c9317c58a424e3D",
        symbol: "BAL",
      },
    ],
  },
  {
    bpt: "0x8fE054748Fc5c8eE50AB8860409a4E9e760E13f4",
    id: "0x8fe054748fc5c8ee50ab8860409a4e9e760e13f4000200000000000000000328",
    name: "50WETH-50EUL",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xd9Fcd98c322942075A5C3860693e9f4f03AAE07b",
        symbol: "EUL",
      },
    ],
  },
  {
    bpt: "0x90291319F1D4eA3ad4dB0Dd8fe9E12BAF749E845",
    id: "0x90291319f1d4ea3ad4db0dd8fe9e12baf749e84500020000000000000000013c",
    name: "B-30FEI-70WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x956F47F50A910163D8BF957Cf5846D573E7f87CA",
        symbol: "FEI",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x9137F3A026Fa419a7a9a0bA8DF6601D4B0aBfd26",
    id: "0x9137f3a026fa419a7a9a0ba8df6601d4b0abfd260002000000000000000001ab",
    name: "BBPT",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xF17e65822b568B3903685a7c9F496CF7656Cc6C2",
        symbol: "BICO",
      },
    ],
  },
  {
    bpt: "0x9232a548DD9E81BaC65500b5e0d918F8Ba93675C",
    id: "0x9232a548dd9e81bac65500b5e0d918f8ba93675c000200000000000000000423",
    name: "BAL-20WETH-80LIT",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xfd0205066521550D7d7AB19DA8F72bb004b4C341",
        symbol: "LIT",
      },
    ],
  },
  {
    bpt: "0x92762B42A06dCDDDc5B7362Cfb01E631c4D44B40",
    id: "0x92762b42a06dcdddc5b7362cfb01e631c4d44b40000200000000000000000182",
    name: "50COW-50GNO",
    type: "Weighted",
    gauge: "0x57AB3b673878C3fEaB7f8FF434C40Ab004408c4c",
    tokens: [
      {
        address: "0x6810e776880C02933D47DB1b9fc05908e5386b96",
        symbol: "GNO",
      },
      {
        address: "0xDEf1CA1fb7FBcDC777520aa7f396b4E015F497aB",
        symbol: "COW",
      },
    ],
  },
  {
    bpt: "0x93ab2aFDED588A9e7F3Ef569834b13685D612f96",
    id: "0x93ab2afded588a9e7f3ef569834b13685d612f96000200000000000000000095",
    name: "80M2-20WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x965d79F1A1016B574a62986e13Ca8Ab04DfdD15C",
        symbol: "M2",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x93d199263632a4EF4Bb438F1feB99e57b4b5f0BD",
    id: "0x93d199263632a4ef4bb438f1feb99e57b4b5f0bd0000000000000000000005c2",
    name: "wstETH-WETH-BPT",
    type: "ComposableStable",
    gauge: "0x5C0F23A5c1be65Fa710d385814a7Fd1Bda480b1C",
    tokens: [
      {
        address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
        symbol: "wstETH",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x95f1A3cA4aF4d08B9C42D65Ef07b66E8222ED85a",
    id: "0x95f1a3ca4af4d08b9c42d65ef07b66e8222ed85a0002000000000000000005b6",
    name: "50somm-50WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xa670d7237398238DE01267472C6f13e5B8010FD1",
        symbol: "somm",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x96646936b91d6B9D7D0c47C496AfBF3D6ec7B6f8",
    id: "0x96646936b91d6b9d7d0c47c496afbf3d6ec7b6f8000200000000000000000019",
    name: "B-50USDC-50WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x96bA9025311e2f47B840A1f68ED57A3DF1EA8747",
    id: "0x96ba9025311e2f47b840a1f68ed57a3df1ea8747000200000000000000000160",
    name: "20DAI-80TCR",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
        symbol: "DAI",
      },
      {
        address: "0x9C4A4204B79dd291D6b6571C5BE8BbcD0622F050",
        symbol: "TCR",
      },
    ],
  },
  {
    bpt: "0x988f2B03Aea264378518B7235d08c6cB2583AAA4",
    id: "0x988f2b03aea264378518b7235d08c6cb2583aaa40001000000000000000004b5",
    name: "29WBTC-4wstETH-67TRAC",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
        symbol: "WBTC",
      },
      {
        address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
        symbol: "wstETH",
      },
      {
        address: "0xaA7a9CA87d3694B5755f213B5D04094b8d0F0A6F",
        symbol: "TRAC",
      },
    ],
  },
  {
    bpt: "0x98b76Fb35387142f97d601A297276bB152Ae8ab0",
    id: "0x98b76fb35387142f97d601a297276bb152ae8ab0000200000000000000000662",
    name: "20WETH-80ONDO",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xfAbA6f8e4a5E8Ab82F62fe7C39859FA577269BE3",
        symbol: "ONDO",
      },
    ],
  },
  {
    bpt: "0x99A14324Cfd525A34BBc93ac7e348929909D57fD",
    id: "0x99a14324cfd525a34bbc93ac7e348929909d57fd00020000000000000000030e",
    name: "50WETH-50FOLD",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xd084944d3c05CD115C09d072B9F44bA3E0E45921",
        symbol: "FOLD",
      },
    ],
  },
  {
    bpt: "0x99e7b15df044e1b62e2e1774fD4469d54D9409aC",
    id: "0x99e7b15df044e1b62e2e1774fd4469d54d9409ac00020000000000000000065a",
    name: "ECLP-GHO-USDC",
    type: "GyroE",
    gauge: "0x5b0ed1fa8850012Db8B075602253335cACD53aD4",
    tokens: [
      {
        address: "0x40D16FC0246aD3160Ccc09B8D0D3A2cD28aE6C2f",
        symbol: "GHO",
      },
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0x9c08C7a7a89cfD671c79eacdc6F07c1996277eD5",
    id: "0x9c08c7a7a89cfd671c79eacdc6f07c1996277ed5000200000000000000000025",
    name: "B-50BAL-50USDC",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
      {
        address: "0xba100000625a3754423978a60c9317c58a424e3D",
        symbol: "BAL",
      },
    ],
  },
  {
    bpt: "0x9c6d47Ff73e0F5E51BE5FD53236e3F595C5793F2",
    id: "0x9c6d47ff73e0f5e51be5fd53236e3f595c5793f200020000000000000000042c",
    name: "B-cbETH-wstETH-Stable",
    type: "MetaStable",
    gauge: null,
    tokens: [
      {
        address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
        symbol: "wstETH",
      },
      {
        address: "0xBe9895146f7AF43049ca1c1AE358B0541Ea49704",
        symbol: "cbETH",
      },
    ],
  },
  {
    bpt: "0x9CC64EE4CB672Bc04C54B00a37E1Ed75b2Cc19Dd",
    id: "0x9cc64ee4cb672bc04c54b00a37e1ed75b2cc19dd0002000000000000000004c1",
    name: "80Silo-20WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x6f80310CA7F2C654691D1383149Fa1A57d8AB1f8",
        symbol: "Silo",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x9e030b67a8384cbba09D5927533Aa98010C87d91",
    id: "0x9e030b67a8384cbba09d5927533aa98010c87d9100020000000000000000008f",
    name: "LPeYyvUSDC-28JAN22",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
      {
        address: "0xF1294E805B992320A3515682c6aB0Fe6251067E5",
        symbol: "eYyvUSDC-28JAN22",
      },
    ],
  },
  {
    bpt: "0x9E7fD25Ad9D97F1e6716fa5bB04749A4621e892d",
    id: "0x9e7fd25ad9d97f1e6716fa5bb04749a4621e892d000100000000000000000039",
    name: "BLC",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x0bc529c00C6401aEF6D220BE8C6Ea1667F6Ad93e",
        symbol: "YFI",
      },
      {
        address: "0x7D1AfA7B718fb893dB30A3aBc0Cfc608AaCfeBB0",
        symbol: "MATIC",
      },
      {
        address: "0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9",
        symbol: "AAVE",
      },
      {
        address: "0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2",
        symbol: "MKR",
      },
      {
        address: "0xba100000625a3754423978a60c9317c58a424e3D",
        symbol: "BAL",
      },
      {
        address: "0xc00e94Cb662C3520282E6f5717214004A7f26888",
        symbol: "COMP",
      },
      {
        address: "0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F",
        symbol: "SNX",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x9F1F16B025F703eE985B58cEd48dAf93daD2f7EF",
    id: "0x9f1f16b025f703ee985b58ced48daf93dad2f7ef00020000000000000000001e",
    name: "B-50BAL-50WBTC",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
        symbol: "WBTC",
      },
      {
        address: "0xba100000625a3754423978a60c9317c58a424e3D",
        symbol: "BAL",
      },
    ],
  },
  {
    bpt: "0x9F2b223dA9F3911698C9b90Ecdf3ffEe37DD54a8",
    id: "0x9f2b223da9f3911698c9b90ecdf3ffee37dd54a8000200000000000000000041",
    name: "50YFU-50WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xa279dab6ec190eE4Efce7Da72896EB58AD533262",
        symbol: "YFU",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x9F9d900462492D4C21e9523ca95A7CD86142F298",
    id: "0x9f9d900462492d4c21e9523ca95a7cd86142f298000200000000000000000462",
    name: "50rETH-50RPL",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xae78736Cd615f374D3085123A210448E74Fc6393",
        symbol: "rETH",
      },
      {
        address: "0xD33526068D116cE69F19A9ee46F0bd304F21A51f",
        symbol: "RPL",
      },
    ],
  },
  {
    bpt: "0xa02E4b3d18D4E6B8d18Ac421fBc3dfFF8933c40a",
    id: "0xa02e4b3d18d4e6b8d18ac421fbc3dfff8933c40a00020000000000000000004b",
    name: "B-50MATIC-50WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x7D1AfA7B718fb893dB30A3aBc0Cfc608AaCfeBB0",
        symbol: "MATIC",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xa33E376932b2c01323F0A7f9bBe0a53F7662B2E9",
    id: "0xa33e376932b2c01323f0a7f9bbe0a53f7662b2e900010000000000000000031d",
    name: "14YFI-14UNI-14WBTC-14CHZ-14LINK-14COMP-14WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x0bc529c00C6401aEF6D220BE8C6Ea1667F6Ad93e",
        symbol: "YFI",
      },
      {
        address: "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984",
        symbol: "UNI",
      },
      {
        address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
        symbol: "WBTC",
      },
      {
        address: "0x3506424F91fD33084466F402d5D97f05F8e3b4AF",
        symbol: "CHZ",
      },
      {
        address: "0x514910771AF9Ca656af840dff83E8264EcF986CA",
        symbol: "LINK",
      },
      {
        address: "0xc00e94Cb662C3520282E6f5717214004A7f26888",
        symbol: "COMP",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xa3C500969accb3D8DF08CBa313C120818fE0ed9D",
    id: "0xa3c500969accb3d8df08cba313c120818fe0ed9d000200000000000000000471",
    name: "50SYN-50WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x0f2D719407FdBeFF09D87557AbB7232601FD9F29",
        symbol: "SYN",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xa5533A44D06800Eaf2DaAD5aAd3f9AA9e1DC3614",
    id: "0xa5533a44d06800eaf2daad5aad3f9aa9e1dc36140002000000000000000001b8",
    name: "20PAR-80MIMO",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x68037790A0229e9Ce6EaA8A99ea92964106C4703",
        symbol: "PAR",
      },
      {
        address: "0x90B831fa3Bebf58E9744A14D638E25B4eE06f9Bc",
        symbol: "MIMO",
      },
    ],
  },
  {
    bpt: "0xA6F548DF93de924d73be7D25dC02554c6bD66dB5",
    id: "0xa6f548df93de924d73be7d25dc02554c6bd66db500020000000000000000000e",
    name: "B-50WBTC-50WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
        symbol: "WBTC",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xA7Ff759DBeF9F3EFDD1d59Beee44b966AcAfe214",
    id: "0xa7ff759dbef9f3efdd1d59beee44b966acafe214000200000000000000000180",
    name: "USDC-PAL",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
      {
        address: "0xAB846Fb6C81370327e784Ae7CbB6d6a6af6Ff4BF",
        symbol: "PAL",
      },
    ],
  },
  {
    bpt: "0xa8210885430aaA333c9F0D66AB5d0c312beD5E43",
    id: "0xa8210885430aaa333c9f0d66ab5d0c312bed5e43000200000000000000000692",
    name: "50wstETH-50sUSDe",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
        symbol: "wstETH",
      },
      {
        address: "0x9D39A5DE30e57443BfF2A8307A4256c8797A3497",
        symbol: "sUSDe",
      },
    ],
  },
  {
    bpt: "0xaA7a70070E7495fe86c67225329DbD39BAa2F63b",
    id: "0xaa7a70070e7495fe86c67225329dbd39baa2f63b000200000000000000000663",
    name: "ECLP-GHO-GYD",
    type: "GyroE",
    gauge: null,
    tokens: [
      {
        address: "0x40D16FC0246aD3160Ccc09B8D0D3A2cD28aE6C2f",
        symbol: "GHO",
      },
      {
        address: "0xe07F9D810a48ab5c3c914BA3cA53AF14E4491e8A",
        symbol: "GYD",
      },
    ],
  },
  {
    bpt: "0xaac98EE71D4F8A156B6abaa6844Cdb7789d086CE",
    id: "0xaac98ee71d4f8a156b6abaa6844cdb7789d086ce00020000000000000000001b",
    name: "B-60MKR-40WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2",
        symbol: "MKR",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xAd07B1FDc60FE102931ca713Ae6DD578E965b94d",
    id: "0xad07b1fdc60fe102931ca713ae6dd578e965b94d0002000000000000000006bd",
    name: "50AUSD-50USDT",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x00000000eFE302BEAA2b3e6e1b18d08D69a9012a",
        symbol: "AUSD",
      },
      {
        address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
        symbol: "USDT",
      },
    ],
  },
  {
    bpt: "0xae2D97CbBc13B67988ECEd2abA0F6939655eD3De",
    id: "0xae2d97cbbc13b67988eced2aba0f6939655ed3de00020000000000000000068b",
    name: "ECLP-paUSD-GYD",
    type: "GyroE",
    gauge: "0x30cEE2F8Cb8e53FC587f6B2578241a118188D530",
    tokens: [
      {
        address: "0x571f54D23cDf2211C83E9A0CbD92AcA36c48Fa02",
        symbol: "paUSD",
      },
      {
        address: "0xe07F9D810a48ab5c3c914BA3cA53AF14E4491e8A",
        symbol: "GYD",
      },
    ],
  },
  {
    bpt: "0xB0401Ab1108BD26C85A07243dFDF09F4821D76a2",
    id: "0xb0401ab1108bd26c85a07243dfdf09f4821d76a200020000000000000000007f",
    name: "EGLBPT",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x1e83916Ea2EF2D7a6064775662E163b2D4C330a7",
        symbol: "EGL",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xB06bFBD7b50F80c8d9dA57Fc4cF5CBD5B3E2f148",
    id: "0xb06bfbd7b50f80c8d9da57fc4cf5cbd5b3e2f14800000000000000000000064d",
    name: "pxETH/frxETH",
    type: "ComposableStable",
    gauge: null,
    tokens: [
      {
        address: "0x04C154b66CB340F3Ae24111CC767e0184Ed00Cc6",
        symbol: "pxETH",
      },
      {
        address: "0x5E8422345238F34275888049021821E8E08CAa1f",
        symbol: "frxETH",
      },
    ],
  },
  {
    bpt: "0xB08885e6026bab4333A80024Ec25a1a3e1FF2b8A",
    id: "0xb08885e6026bab4333a80024ec25a1a3e1ff2b8a000200000000000000000445",
    name: "B-staFiETH-WETH-Stable",
    type: "MetaStable",
    gauge: null,
    tokens: [
      {
        address: "0x9559Aaa82d9649C7A7b220E7c461d2E74c9a3593",
        symbol: "rETH",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xb3b675a9A3CB0DF8F66Caf08549371BfB76A9867",
    id: "0xb3b675a9a3cb0df8f66caf08549371bfb76a9867000200000000000000000611",
    name: "ECLP-mevETH-wETH",
    type: "GyroE",
    gauge: null,
    tokens: [
      {
        address: "0x24Ae2dA0f361AA4BE46b48EB19C91e02c5e4f27E",
        symbol: "mevETH",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xb460DAa847c45f1C4a41cb05BFB3b51c92e41B36",
    id: "0xb460daa847c45f1c4a41cb05bfb3b51c92e41b36000200000000000000000194",
    name: "20WBTC-80BADGER",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
        symbol: "WBTC",
      },
      {
        address: "0x3472A5A71965499acd81997a54BBA8D852C6E53d",
        symbol: "BADGER",
      },
    ],
  },
  {
    bpt: "0xB53f8F2907d8E5fED503f8ebCe4433FB5c5BEae2",
    id: "0xb53f8f2907d8e5fed503f8ebce4433fb5c5beae200020000000000000000041e",
    name: "80wARRR-20WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x057acee6DF29EcC20e87A77783838d90858c5E83",
        symbol: "wARRR",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xB6b9B165C4AC3f5233A0CF413126C72Be28B468A",
    id: "0xb6b9b165c4ac3f5233a0cf413126c72be28b468a00010000000000000000005a",
    name: "DEFI1",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984",
        symbol: "UNI",
      },
      {
        address: "0x6B3595068778DD592e39A122f4f5a5cF09C90fE2",
        symbol: "SUSHI",
      },
      {
        address: "0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9",
        symbol: "AAVE",
      },
      {
        address: "0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2",
        symbol: "MKR",
      },
      {
        address: "0xba100000625a3754423978a60c9317c58a424e3D",
        symbol: "BAL",
      },
      {
        address: "0xc00e94Cb662C3520282E6f5717214004A7f26888",
        symbol: "COMP",
      },
      {
        address: "0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F",
        symbol: "SNX",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xB704aA724E69601Ffdc9B748137491BFfa1B858D",
    id: "0xb704aa724e69601ffdc9b748137491bffa1b858d0001000000000000000004a1",
    name: "33QOM-33O-33CAW",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xa71d0588EAf47f12B13cF8eC750430d21DF04974",
        symbol: "QOM",
      },
      {
        address: "0xb53ecF1345caBeE6eA1a65100Ebb153cEbcac40f",
        symbol: "O",
      },
      {
        address: "0xf3b9569F82B18aEf890De263B84189bd33EBe452",
        symbol: "CAW",
      },
    ],
  },
  {
    bpt: "0xB70c25D96EF260eA07F650037Bf68F5d6583885e",
    id: "0xb70c25d96ef260ea07f650037bf68f5d6583885e000200000000000000000096",
    name: "LPeYyvDAI-28JAN22",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
        symbol: "DAI",
      },
      {
        address: "0xF6d2699b035FC8fD5E023D4a6Da216112ad8A985",
        symbol: "eYyvDAI-28JAN22",
      },
    ],
  },
  {
    bpt: "0xb8E2cBb2455E80ad0eb536AE30a5290bDD7Baa91",
    id: "0xb8e2cbb2455e80ad0eb536ae30a5290bdd7baa9100020000000000000000055f",
    name: "80BREWSKI-20WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x9E3c6575f674BdeE85731d23259971Aa6ddA7b9b",
        symbol: "BREWSKI",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xb986Fd52697f16bE888bFAD2c5bF12cd67Ce834B",
    id: "0xb986fd52697f16be888bfad2c5bf12cd67ce834b000200000000000000000634",
    name: "stADS",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x3106a0a076BeDAE847652F42ef07FD58589E001f",
        symbol: "$ADS",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xBA9Cc2cff8858CFa72B28d316F3bf3f31b68E080",
    id: "0xba9cc2cff8858cfa72b28d316f3bf3f31b68e0800001000000000000000006ab",
    name: "BTC-ETH-GOLD",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
        symbol: "WBTC",
      },
      {
        address: "0x45804880De22913dAFE09f4980848ECE6EcbAf78",
        symbol: "PAXG",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xBaeEC99c90E3420Ec6c1e7A769d2A856d2898e4D",
    id: "0xbaeec99c90e3420ec6c1e7a769d2a856d2898e4d00020000000000000000008a",
    name: "B-50VITA-50WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x81f8f0bb1cB2A06649E51913A151F0E7Ef6FA321",
        symbol: "VITA",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xBb31b8EEBB9C71001562AE56Aa5751Af313e6d89",
    id: "0xbb31b8eebb9c71001562ae56aa5751af313e6d8900020000000000000000002e",
    name: "B-80TRU-20WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xf65B5C5104c4faFD4b709d9D60a185eAE063276c",
        symbol: "TRU",
      },
    ],
  },
  {
    bpt: "0xBF96189Eee9357a95C7719f4F5047F76bdE804E5",
    id: "0xbf96189eee9357a95c7719f4f5047f76bde804e5000200000000000000000087",
    name: "B-80LDO-20WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x5A98FcBEA516Cf06857215779Fd812CA3beF1B32",
        symbol: "LDO",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xc29562b045D80fD77c69Bec09541F5c16fe20d9d",
    id: "0xc29562b045d80fd77c69bec09541f5c16fe20d9d000200000000000000000251",
    name: "B-80AURA-20WETH",
    type: "Weighted",
    gauge: "0x006aaD228d44655c4C97CDda600f2d56E99569B9",
    tokens: [
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xC0c293ce456fF0ED870ADd98a0828Dd4d2903DBF",
        symbol: "AURA",
      },
    ],
  },
  {
    bpt: "0xC2AA60465BfFa1A88f5bA471a59cA0435c3ec5c1",
    id: "0xc2aa60465bffa1a88f5ba471a59ca0435c3ec5c100020000000000000000062c",
    name: "ECLP-GYD-USDC",
    type: "GyroE",
    gauge: null,
    tokens: [
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
      {
        address: "0xe07F9D810a48ab5c3c914BA3cA53AF14E4491e8A",
        symbol: "GYD",
      },
    ],
  },
  {
    bpt: "0xc45D42f801105e861e86658648e3678aD7aa70f9",
    id: "0xc45d42f801105e861e86658648e3678ad7aa70f900010000000000000000011e",
    name: "50OHM-25DAI-25WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x64aa3364F17a4D01c6f1751Fd97C2BD3D7e7f1D5",
        symbol: "OHM",
      },
      {
        address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
        symbol: "DAI",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xC5c91aea7551095c3E1FF0f94f682c45b347AD73",
    id: "0xc5c91aea7551095c3e1ff0f94f682c45b347ad730002000000000000000006c0",
    name: "80BAL20wETH/wETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x5c6Ee304399DBdB9C8Ef030aB642B10820DB8F56",
        symbol: "B-80BAL-20WETH",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xC683955059e98350DE4e5Dc1C75971bD640829Bb",
    id: "0xc683955059e98350de4e5dc1c75971bd640829bb0002000000000000000006e1",
    name: "ECLP-cbETH-wstETH",
    type: "GyroE",
    gauge: null,
    tokens: [
      {
        address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
        symbol: "wstETH",
      },
      {
        address: "0xBe9895146f7AF43049ca1c1AE358B0541Ea49704",
        symbol: "cbETH",
      },
    ],
  },
  {
    bpt: "0xC6A5032dC4bF638e15b4a66BC718ba7bA474FF73",
    id: "0xc6a5032dc4bf638e15b4a66bc718ba7ba474ff73000200000000000000000004",
    name: "B-60WETH-40DAI",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
        symbol: "DAI",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xc88c76dD8b92408Fe9bEa1a54922A31E232d873c",
    id: "0xc88c76dd8b92408fe9bea1a54922a31e232d873c0002000000000000000005b2",
    name: "80ASX-20WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x67d85A291fcDC862A78812a3C26d55e28FFB2701",
        symbol: "ASX",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xC8cF54b0b70899Ea846B70361e62F3F5B22b1f4B",
    id: "0xc8cf54b0b70899ea846b70361e62f3f5b22b1f4b0002000000000000000006c7",
    name: "ECLP-wstETH-GYD",
    type: "GyroE",
    gauge: "0xCda69C40176B98bB1773109d1fEa91e12F478451",
    tokens: [
      {
        address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
        symbol: "wstETH",
      },
      {
        address: "0xe07F9D810a48ab5c3c914BA3cA53AF14E4491e8A",
        symbol: "GYD",
      },
    ],
  },
  {
    bpt: "0xCB0e14e96f2cEFA8550ad8e4aeA344F211E5061d",
    id: "0xcb0e14e96f2cefa8550ad8e4aea344f211e5061d00020000000000000000011a",
    name: "20WETH-80PSP",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xcAfE001067cDEF266AfB7Eb5A286dCFD277f3dE5",
        symbol: "PSP",
      },
    ],
  },
  {
    bpt: "0xcCF5575570faC94CEC733a58ff91bB3d073085c7",
    id: "0xccf5575570fac94cec733a58ff91bb3d073085c70002000000000000000000af",
    name: "iROBOT",
    type: "Investment",
    gauge: null,
    tokens: [
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xfb5453340C03db5aDe474b27E68B6a9c6b2823Eb",
        symbol: "ROBOT",
      },
    ],
  },
  {
    bpt: "0xcF7b51ce5755513d4bE016b0e28D6EDEffa1d52a",
    id: "0xcf7b51ce5755513d4be016b0e28d6edeffa1d52a000200000000000000000617",
    name: "RDNT-WETH",
    type: "Weighted",
    gauge: "0xF22BbdAd6B3Dd9314BdF97724DF32b09Ff95C216",
    tokens: [
      {
        address: "0x137dDB47Ee24EaA998a535Ab00378d6BFa84F893",
        symbol: "RDNT",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xcF8dFdb73e7434b05903B5599fB96174555F4353",
    id: "0xcf8dfdb73e7434b05903b5599fb96174555f43530002000000000000000006c3",
    name: "60GOLD-40WETH",
    type: "Weighted",
    gauge: "0xC219821b1FE1bBe436f62D911F00Ef1C8542A8F7",
    tokens: [
      {
        address: "0x583019fF0f430721aDa9cfb4fac8F06cA104d0B4",
        symbol: "st-yETH",
      },
      {
        address: "0x9DeB0fc809955b79c85e82918E8586d3b7d2695a",
        symbol: "GOLD",
      },
    ],
  },
  {
    bpt: "0xCfCA23cA9CA720B6E98E3Eb9B6aa0fFC4a5C08B9",
    id: "0xcfca23ca9ca720b6e98e3eb9b6aa0ffc4a5c08b9000200000000000000000274",
    name: "50WETH-50AURA",
    type: "Weighted",
    gauge: "0x275dF57d2B23d53e20322b4bb71Bf1dCb21D0A00",
    tokens: [
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xC0c293ce456fF0ED870ADd98a0828Dd4d2903DBF",
        symbol: "AURA",
      },
    ],
  },
  {
    bpt: "0xD1eC5e215E8148D76F4460e4097FD3d5ae0A3558",
    id: "0xd1ec5e215e8148d76f4460e4097fd3d5ae0a35580002000000000000000003d3",
    name: "50OHM-50WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x64aa3364F17a4D01c6f1751Fd97C2BD3D7e7f1D5",
        symbol: "OHM",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xD278166DAbaf26707362f7CfDd204b277FD2a460",
    id: "0xd278166dabaf26707362f7cfdd204b277fd2a4600002000000000000000004f6",
    name: "50USH-50WETH",
    type: "Weighted",
    gauge: "0x6B29de6b961F60A494416164B651eeeA71b7aED7",
    tokens: [
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xE60779CC1b2c1d0580611c526a8DF0E3f870EC48",
        symbol: "USH",
      },
    ],
  },
  {
    bpt: "0xd4E2af4507B6B89333441C0c398edfFB40f86f4D",
    id: "0xd4e2af4507b6b89333441c0c398edffb40f86f4d0001000000000000000002ab",
    name: "33WBTC-33WETH-33WAMPL",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
        symbol: "WBTC",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xEDB171C18cE90B633DB442f2A6F72874093b49Ef",
        symbol: "WAMPL",
      },
    ],
  },
  {
    bpt: "0xd4f79CA0Ac83192693bce4699d0c10C66Aa6Cf0F",
    id: "0xd4f79ca0ac83192693bce4699d0c10c66aa6cf0f00020000000000000000047e",
    name: "OHM-wstETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x64aa3364F17a4D01c6f1751Fd97C2BD3D7e7f1D5",
        symbol: "OHM",
      },
      {
        address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
        symbol: "wstETH",
      },
    ],
  },
  {
    bpt: "0xd590931466cdD6d488A25da1E89dD0539723800c",
    id: "0xd590931466cdd6d488a25da1e89dd0539723800c00020000000000000000042b",
    name: "50RBN-50USDC",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x6123B0049F904d730dB3C36a31167D9d4121fA6B",
        symbol: "RBN",
      },
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0xd5A44704beFD1CfCCa67F7bc498a7654cC092959",
    id: "0xd5a44704befd1cfcca67f7bc498a7654cc092959000200000000000000000609",
    name: "BAL-20WETH-80POP",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xD0Cd466b34A24fcB2f87676278AF2005Ca8A78c4",
        symbol: "POP",
      },
    ],
  },
  {
    bpt: "0xd689ABc77B82803F22c49dE5C8A0049Cc74D11fD",
    id: "0xd689abc77b82803f22c49de5c8a0049cc74d11fd000200000000000000000524",
    name: "80USH-20unshETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x0Ae38f7E10A43B5b2fB064B42a2f4514cbA909ef",
        symbol: "unshETH",
      },
      {
        address: "0xE60779CC1b2c1d0580611c526a8DF0E3f870EC48",
        symbol: "USH",
      },
    ],
  },
  {
    bpt: "0xd8721E92BA0F8235B375E9ec9a7B697Ec4e2D6c6",
    id: "0xd8721e92ba0f8235b375e9ec9a7b697ec4e2d6c6000200000000000000000575",
    name: "80BIDS-20WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xA53e968b8d8a5Be52d66e5BB35d9b6B6B5A5CD2F",
        symbol: "BIDS",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xd8833594420dB3D6589c1098dbDd073f52419Dba",
    id: "0xd8833594420db3d6589c1098dbdd073f52419dba000100000000000000000134",
    name: "vNFT",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x114f1388fAB456c4bA31B1850b244Eedcd024136",
        symbol: "COOL",
      },
      {
        address: "0x269616D549D7e8Eaa82DFb17028d0B212D11232A",
        symbol: "PUNK",
      },
      {
        address: "0xe1406825186D63980fd6e2eC61888f7B91C4bAe4",
        symbol: "VBTC",
      },
      {
        address: "0xEA47B64e1BFCCb773A0420247C0aa0a3C1D2E5C5",
        symbol: "BAYC",
      },
    ],
  },
  {
    bpt: "0xD9Fb1aE180Fbf88F28f14a04842bD17BCEb69fEf",
    id: "0xd9fb1ae180fbf88f28f14a04842bd17bceb69fef000200000000000000000316",
    name: "80SLR-20WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x4E9e4Ab99Cfc14B852f552f5Fb3Aa68617825B6c",
        symbol: "SLR",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xdB3e5Cf969c05625Db344deA9C8b12515e235Df3",
    id: "0xdb3e5cf969c05625db344dea9c8b12515e235df300010000000000000000006a",
    name: "DEFI3",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x0cEC1A9154Ff802e7934Fc916Ed7Ca50bDE6844e",
        symbol: "POOL",
      },
      {
        address: "0x2ba592F78dB6436527729929AAf6c908497cB200",
        symbol: "CREAM",
      },
      {
        address: "0x584bC13c7D411c00c01A62e8019472dE68768430",
        symbol: "HEGIC",
      },
      {
        address: "0x6DEA81C8171D0bA574754EF6F8b412F2Ed88c54D",
        symbol: "LQTY",
      },
      {
        address: "0xBB0E17EF65F82Ab018d8EDd776e8DD940327B28b",
        symbol: "AXS",
      },
      {
        address: "0xbC396689893D065F41bc2C6EcbeE5e0085233447",
        symbol: "PERP",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xdBdb4d16EdA451D0503b854CF79D55697F90c8DF",
        symbol: "ALCX",
      },
    ],
  },
  {
    bpt: "0xdCb5ED405a9b11250deF047AE8016008Fae7D69b",
    id: "0xdcb5ed405a9b11250def047ae8016008fae7d69b0000000000000000000006d8",
    name: "WETH-lpETH",
    type: "ComposableStable",
    gauge: "0xC955F20bF483cE259566b080Fb55d5BF0A51f7d9",
    tokens: [
      {
        address: "0xa684EAf215ad323452e2B2bF6F817d4aa5C116ab",
        symbol: "lpETH",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xdE148e6cC3F6047EeD6E97238D341A2b8589e19E",
    id: "0xde148e6cc3f6047eed6e97238d341a2b8589e19e000200000000000000000017",
    name: "B-60WETH-40BAT",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x0D8775F648430679A709E98d2b0Cb6250d2887EF",
        symbol: "BAT",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xde8C195Aa41C11a0c4787372deFBbDdAa31306D2",
    id: "0xde8c195aa41c11a0c4787372defbbddaa31306d2000200000000000000000181",
    name: "50COW-50WETH",
    type: "Weighted",
    gauge: "0x7C777eEA1dC264e71E567Fcc9B6DdaA9064Eff51",
    tokens: [
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xDEf1CA1fb7FBcDC777520aa7f396b4E015F497aB",
        symbol: "COW",
      },
    ],
  },
  {
    bpt: "0xDf2c03c12442c7A0895455A48569B889079cA52A",
    id: "0xdf2c03c12442c7a0895455a48569b889079ca52a000200000000000000000538",
    name: "80ARCH-20WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x73C69d24ad28e2d43D03CBf35F79fE26EBDE1011",
        symbol: "ARCH",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xe0E8AC08De6708603cFd3D23B613d2f80e3b7afB",
    id: "0xe0e8ac08de6708603cfd3d23b613d2f80e3b7afb00020000000000000000058a",
    name: "ECLP-wstETH-swETH",
    type: "GyroE",
    gauge: "0xe74795EC9251E2381f490a4a5b8BE1D3FA73DE82",
    tokens: [
      {
        address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
        symbol: "wstETH",
      },
      {
        address: "0xf951E335afb289353dc249e82926178EaC7DEd78",
        symbol: "swETH",
      },
    ],
  },
  {
    bpt: "0xE24281bc68C2a56e19B67b3787Fd5e95937bd970",
    id: "0xe24281bc68c2a56e19b67b3787fd5e95937bd970000200000000000000000062",
    name: "50WPE-50WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xd075e95423C5c4BA1E122CaE0f4CdFA19b82881b",
        symbol: "wPE",
      },
    ],
  },
  {
    bpt: "0xe2469f47aB58cf9CF59F9822e3C5De4950a41C49",
    id: "0xe2469f47ab58cf9cf59f9822e3c5de4950a41c49000200000000000000000089",
    name: "mBPT",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xa3BeD4E1c75D00fa6f4E5E6922DB7261B5E9AcD2",
        symbol: "MTA",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xE4010EF5E37dc23154680f23c4A0d48BFca91687",
    id: "0xe4010ef5e37dc23154680f23c4a0d48bfca91687000200000000000000000432",
    name: "80SD-20WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x30D20208d987713f46DFD34EF128Bb16C404D10f",
        symbol: "SD",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xe4e72f872c4048925a78E1e6Fddac411C9ae348A",
    id: "0xe4e72f872c4048925a78e1e6fddac411c9ae348a0000000000000000000005bc",
    name: "2BTC",
    type: "ComposableStable",
    gauge: "0x21c377cBB2bEdDd8534308E5CdfeBE35fDF817E8",
    tokens: [
      {
        address: "0x18084fbA666a33d37592fA2633fD49a74DD93a88",
        symbol: "tBTC",
      },
      {
        address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
        symbol: "WBTC",
      },
    ],
  },
  {
    bpt: "0xE54B3F5c444a801e61BECDCa93e74CdC1C4C1F90",
    id: "0xe54b3f5c444a801e61becdca93e74cdc1c4c1f90000200000000000000000077",
    name: "LPeYyvDAI-16OCT21",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
        symbol: "DAI",
      },
      {
        address: "0xA1Cc9BBcd3731A9fd43E1F1416f9B6Bf824F37D7",
        symbol: "eYyvDAI-16OCT21",
      },
    ],
  },
  {
    bpt: "0xE7B1D394f3b40ABeAa0b64a545Dbcf89da1ecB3f",
    id: "0xe7b1d394f3b40abeaa0b64a545dbcf89da1ecb3f00010000000000000000009a",
    name: "WSB-MACRO",
    type: "Investment",
    gauge: null,
    tokens: [
      {
        address: "0x123151402076fc819B7564510989e475c9cD93CA",
        symbol: "wDGLD",
      },
      {
        address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
        symbol: "WBTC",
      },
      {
        address: "0x68037790A0229e9Ce6EaA8A99ea92964106C4703",
        symbol: "PAR",
      },
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xe8cc7E765647625B95F59C15848379D10B9AB4af",
    id: "0xe8cc7e765647625b95f59c15848379d10b9ab4af0002000000000000000001de",
    name: "20WETH-80WNCG",
    type: "Weighted",
    gauge: "0x47c56A900295df5224EC5e6751dC31eb900321D5",
    tokens: [
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xf203Ca1769ca8e9e8FE1DA9D147DB68B6c919817",
        symbol: "WNCG",
      },
    ],
  },
  {
    bpt: "0xe91888a1D08E37598867d213a4ACB5692071BB3a",
    id: "0xe91888a1d08e37598867d213a4acb5692071bb3a0002000000000000000005f9",
    name: "20R-80RAFT",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x183015a9bA6fF60230fdEaDc3F43b3D788b13e21",
        symbol: "R",
      },
      {
        address: "0x4C5Cb5D87709387f8821709f7a6664f00DcF0C93",
        symbol: "RAFT",
      },
    ],
  },
  {
    bpt: "0xE99481DC77691d8E2456E5f3F61C1810adFC1503",
    id: "0xe99481dc77691d8e2456e5f3f61c1810adfc1503000200000000000000000018",
    name: "B-50LINK-50WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x514910771AF9Ca656af840dff83E8264EcF986CA",
        symbol: "LINK",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xEA39581977325C0833694D51656316Ef8A926a62",
    id: "0xea39581977325c0833694d51656316ef8a926a62000200000000000000000036",
    name: "75xSNXa-25WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x1Cf0f3AaBE4D12106B27Ab44df5473974279C524",
        symbol: "xSNXa",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xEA8886a24b6e01Fba88A9e98d794e8D1F29eD863",
    id: "0xea8886a24b6e01fba88a9e98d794e8d1f29ed863000200000000000000000010",
    name: "B-75ZRX-25WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xE41d2489571d322189246DaFA5ebDe1F4699F498",
        symbol: "ZRX",
      },
    ],
  },
  {
    bpt: "0xeBC5028d2A6080d0455348E352B16C58e1771FdF",
    id: "0xebc5028d2a6080d0455348e352b16c58e1771fdf0002000000000000000006f6",
    name: "ECLP-WETH-USDC-dyn",
    type: "GyroE",
    gauge: "0xd1AaB9Be6280f314C239975B0097122a87fCa583",
    tokens: [
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xeC60a5FeF79a92c741Cb74FdD6bfC340C0279B01",
    id: "0xec60a5fef79a92c741cb74fdd6bfc340c0279b01000200000000000000000015",
    name: "B-50REN-50WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x408e41876cCCDC0F92210600ef50372656052a38",
        symbol: "REN",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xee3959FD00a0B996d801fc34B7CE566bD037f5f5",
    id: "0xee3959fd00a0b996d801fc34b7ce566bd037f5f500020000000000000000063e",
    name: "80MIMO-20WETH",
    type: "Weighted",
    gauge: "0x6be156504Cda8ee38169BE96Bcf53AEAB4377c1a",
    tokens: [
      {
        address: "0x90B831fa3Bebf58E9744A14D638E25B4eE06f9Bc",
        symbol: "MIMO",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xEFAa1604e82e1B3AF8430b90192c1B9e8197e377",
    id: "0xefaa1604e82e1b3af8430b90192c1b9e8197e377000200000000000000000021",
    name: "B-50COMP-50WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xc00e94Cb662C3520282E6f5717214004A7f26888",
        symbol: "COMP",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xf01b0684C98CD7aDA480BFDF6e43876422fa1Fc1",
    id: "0xf01b0684c98cd7ada480bfdf6e43876422fa1fc10002000000000000000005de",
    name: "ECLP-wstETH-wETH",
    type: "GyroE",
    gauge: null,
    tokens: [
      {
        address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
        symbol: "wstETH",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xf16aEe6a71aF1A9Bc8F56975A4c2705ca7A782Bc",
    id: "0xf16aee6a71af1a9bc8f56975a4c2705ca7a782bc0002000000000000000004bb",
    name: "20WETH-80ALCX",
    type: "Weighted",
    gauge: "0x183D73dA7adC5011EC3C46e33BB50271e59EC976",
    tokens: [
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xdBdb4d16EdA451D0503b854CF79D55697F90c8DF",
        symbol: "ALCX",
      },
    ],
  },
  {
    bpt: "0xf33A6B68D2f6ae0353746C150757E4c494e02366",
    id: "0xf33a6b68d2f6ae0353746c150757e4c494e02366000200000000000000000117",
    name: "MTRL-ELA Liquidity Pool",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x13C99770694f07279607A6274F28a28c33086424",
        symbol: "MTRL",
      },
      {
        address: "0xe6fd75ff38Adca4B97FBCD938c86b98772431867",
        symbol: "ELA",
      },
    ],
  },
  {
    bpt: "0xF3a605DA753e9dE545841de10EA8bFfBd1Da9C75",
    id: "0xf3a605da753e9de545841de10ea8bffbd1da9c75000200000000000000000035",
    name: "sdveCRV90-CRV10",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x478bBC744811eE8310B461514BDc29D03739084D",
        symbol: "sdveCRV-DAO",
      },
      {
        address: "0xD533a949740bb3306d119CC777fa900bA034cd52",
        symbol: "CRV",
      },
    ],
  },
  {
    bpt: "0xf3AeB3aBbA741f0EEcE8a1B1D2F11b85899951CB",
    id: "0xf3aeb3abba741f0eece8a1b1d2f11b85899951cb000200000000000000000351",
    name: "MAI-USDC-SP",
    type: "Stable",
    gauge: null,
    tokens: [
      {
        address: "0x8D6CeBD76f18E1558D4DB88138e2DeFB3909fAD6",
        symbol: "MAI",
      },
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0xF4C0DD9B82DA36C07605df83c8a416F11724d88b",
    id: "0xf4c0dd9b82da36c07605df83c8a416f11724d88b000200000000000000000026",
    name: "B-80GNO-20WETH",
    type: "Weighted",
    gauge: "0xCB664132622f29943f67FA56CCfD1e24CC8B4995",
    tokens: [
      {
        address: "0x6810e776880C02933D47DB1b9fc05908e5386b96",
        symbol: "GNO",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xF506984C16737B1A9577cadeDa02a49fD612Aff8",
    id: "0xf506984c16737b1a9577cadeda02a49fd612aff80002000000000000000002a9",
    name: "50XAI-50USDC",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x35e78b3982E87ecfD5b3f3265B601c046cDBe232",
        symbol: "XAI",
      },
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0xf5aAf7Ee8C39B651CEBF5f1F50C10631E78e0ef9",
    id: "0xf5aaf7ee8c39b651cebf5f1f50c10631e78e0ef9000200000000000000000069",
    name: "BPTUMAUSDC",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x04Fa0d235C4abf4BcF4787aF4CF447DE572eF828",
        symbol: "UMA",
      },
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0xF5f6fb82649DF7991054Ef796C39da81B93364Df",
    id: "0xf5f6fb82649df7991054ef796c39da81b93364df000200000000000000000399",
    name: "50BOND-50OHM",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x0391D2021f89DC339F60Fff84546EA23E337750f",
        symbol: "BOND",
      },
      {
        address: "0x64aa3364F17a4D01c6f1751Fd97C2BD3D7e7f1D5",
        symbol: "OHM",
      },
    ],
  },
  {
    bpt: "0xf8a0623ab66F985EfFc1C69D05F1af4BaDB01b00",
    id: "0xf8a0623ab66f985effc1c69d05f1af4badb01b0000020000000000000000001d",
    name: "B-80UMA-20WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x04Fa0d235C4abf4BcF4787aF4CF447DE572eF828",
        symbol: "UMA",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xf8C4CD95c7496cB7c8d97202Cf7e5b8DA2204C2b",
    id: "0xf8c4cd95c7496cb7c8d97202cf7e5b8da2204c2b00020000000000000000039e",
    name: "80psdnOCEAN-20OCEAN",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x51Fa2efd62ee56a493f24AE963eAce7D0051929E",
        symbol: "psdnOCEAN",
      },
      {
        address: "0x967da4048cD07aB37855c090aAF366e4ce1b9F48",
        symbol: "OCEAN",
      },
    ],
  },
  {
    bpt: "0xfa1575c57D887E93f37A3C267a548Ede008458B3",
    id: "0xfa1575c57d887e93f37a3c267a548ede008458b300010000000000000000008c",
    name: "TSB-BTC-ETH-USDC-Pool",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
        symbol: "WBTC",
      },
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xFB46Bc8FC0D06421D362A31B7230F39462efA79A",
    id: "0xfb46bc8fc0d06421d362a31b7230f39462efa79a000200000000000000000332",
    name: "20OHM-80FDT",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x64aa3364F17a4D01c6f1751Fd97C2BD3D7e7f1D5",
        symbol: "OHM",
      },
      {
        address: "0xEd1480d12bE41d92F36f5f7bDd88212E381A3677",
        symbol: "FDT",
      },
    ],
  },
  {
    bpt: "0xfbfaD5fa9E99081da6461F36f229B5cC88A64c63",
    id: "0xfbfad5fa9e99081da6461f36f229b5cc88a64c6300020000000000000000062d",
    name: "ECLP-GYD-USDT",
    type: "GyroE",
    gauge: "0xfC7D964f1676831d8105506b1F0c3B3e2B55c467",
    tokens: [
      {
        address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
        symbol: "USDT",
      },
      {
        address: "0xe07F9D810a48ab5c3c914BA3cA53AF14E4491e8A",
        symbol: "GYD",
      },
    ],
  },
  {
    bpt: "0xFD1Cf6FD41F229Ca86ada0584c63C49C3d66BbC9",
    id: "0xfd1cf6fd41f229ca86ada0584c63c49c3d66bbc9000200000000000000000438",
    name: "50PENDLE-50WETH",
    type: "Weighted",
    gauge: "0x190AE1f6EE5c0B7bc193fA9CD9bBe9b335F69C65",
    tokens: [
      {
        address: "0x808507121B80c02388fAd14726482e061B8da827",
        symbol: "PENDLE",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0xFeadd389a5c427952D8fdb8057D6C8ba1156cC56",
    id: "0xfeadd389a5c427952d8fdb8057d6c8ba1156cc56000000000000000000000066",
    name: "staBAL3-BTC",
    type: "Stable",
    gauge: null,
    tokens: [
      {
        address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
        symbol: "WBTC",
      },
      {
        address: "0xEB4C2781e4ebA804CE9a9803C67d0893436bB27D",
        symbol: "renBTC",
      },
      {
        address: "0xfE18be6b3Bd88A2D2A7f928d00292E7a9963CfC6",
        symbol: "sBTC",
      },
    ],
  },
  {
    bpt: "0xfF083f57A556bfB3BBe46Ea1B4Fa154b2b1FBe88",
    id: "0xff083f57a556bfb3bbe46ea1b4fa154b2b1fbe88000200000000000000000030",
    name: "B-80GTC-20WETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xDe30da39c46104798bB5aA3fe8B9e0e1F348163F",
        symbol: "GTC",
      },
    ],
  },
  {
    bpt: "0xFf42A9AF956617e4C3532eF2fC7567465EFE4909",
    id: "0xff42a9af956617e4c3532ef2fc7567465efe4909000200000000000000000672",
    name: "50KEP/50rsETH",
    type: "Weighted",
    gauge: null,
    tokens: [
      {
        address: "0x8E3A59427B1D87Db234Dd4ff63B25E4BF94672f4",
        symbol: "KEP",
      },
      {
        address: "0xA1290d69c65A6Fe4DF752f95823fae25cB99e5A7",
        symbol: "rsETH",
      },
    ],
  },
  {
    bpt: "0xFf4ce5AAAb5a627bf82f4A571AB1cE94Aa365eA6",
    id: "0xff4ce5aaab5a627bf82f4a571ab1ce94aa365ea6000200000000000000000426",
    name: "DOLA-USDC BSP",
    type: "Stable",
    gauge: "0x9298faE35169D51714D6F9462B5f1BB2eD36165a",
    tokens: [
      {
        address: "0x865377367054516e17014CcdED1e7d814EDC9ce4",
        symbol: "DOLA",
      },
      {
        address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        symbol: "USDC",
      },
    ],
  },
  {
    bpt: "0xDACf5Fa19b1f720111609043ac67A9818262850c",
    id: "0xdacf5fa19b1f720111609043ac67a9818262850c000000000000000000000635",
    name: "osETH/wETH-BPT",
    type: "ComposableStable",
    gauge: "0xc592c33e51A764B94DB0702D8BAf4035eD577aED",
    tokens: [
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
      {
        address: "0xf1C9acDc66974dFB6dEcB12aA385b9cD01190E38",
        symbol: "osETH",
      },
    ],
  },
  {
    bpt: "0xB91159aa527D4769CB9FAf3e4ADB760c7E8C8Ea7",
    id: "0xb91159aa527d4769cb9faf3e4adb760c7e8c8ea700000000000000000000067c",
    name: "ETHx/wstETH",
    type: "ComposableStable",
    gauge: "0xAC08fde28aa2D123B61a5dB3074cAF72760FfeEB",
    tokens: [
      {
        address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
        symbol: "wstETH",
      },
      {
        address: "0xA35b1B31Ce002FBF2058D22F30f95D405200A15b",
        symbol: "ETHx",
      },
    ],
  },
  {
    bpt: "0x596192bB6e41802428Ac943D2f1476C1Af25CC0E",
    id: "0x596192bb6e41802428ac943d2f1476c1af25cc0e000000000000000000000659",
    name: "ezETH-WETH-BPT",
    type: "ComposableStable",
    gauge: "0xa8B309a75f0D64ED632d45A003c68A30e59A1D8b",
    tokens: [
      {
        address: "0xbf5495Efe5DB9ce00f80364C8B423567e58d2110",
        symbol: "ezETH",
      },
      {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
      },
    ],
  },
  {
    bpt: "0x05ff47AFADa98a98982113758878F9A8B9FddA0a",
    id: "0x05ff47afada98a98982113758878f9a8b9fdda0a000000000000000000000645",
    name: "weETH/rETH",
    type: "ComposableStable",
    gauge: "0xC859BF9d7B8C557bBd229565124c2C09269F3aEF",
    tokens: [
      {
        address: "0xae78736Cd615f374D3085123A210448E74Fc6393",
        symbol: "rETH",
      },
      {
        address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
        symbol: "weETH",
      },
    ],
  },
] as const
